import {AuthorizedApiBase, IConfig, CancelToken } from "./authorization"
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.0.0 (NJsonSchema v11.6.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface IAppliquettesClient {

    /**
     * Récupère les widgets
     * @return OK
     */
    getWidgets( cancelToken?: CancelToken): Promise<WidgetList>;

    /**
     * Gère les favoris dans les widgets
     * @param modifier Modifie le status de favori d'un widget
     * @return OK
     */
    setFavori(idWidget: number, modifier: UpdateFavoriWidgetModifier,  cancelToken?: CancelToken): Promise<void>;
}

export class AppliquettesClient extends AuthorizedApiBase implements IAppliquettesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère les widgets
     * @return OK
     */
    getWidgets(): Promise<WidgetList> {
        let url_ = this.baseUrl + "/api/v2/appliquettes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWidgets(_response);
        });
    }

    protected processGetWidgets(response: Response): Promise<WidgetList> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WidgetList;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WidgetList>(null as any);
    }

    /**
     * Gère les favoris dans les widgets
     * @param modifier Modifie le status de favori d'un widget
     * @return OK
     */
    setFavori(idWidget: number, modifier: UpdateFavoriWidgetModifier): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/appliquettes/favoris/{idWidget}/{modifier}";
        if (idWidget === undefined || idWidget === null)
            throw new globalThis.Error("The parameter 'idWidget' must be defined.");
        url_ = url_.replace("{idWidget}", encodeURIComponent("" + idWidget));
        if (modifier === undefined || modifier === null)
            throw new globalThis.Error("The parameter 'modifier' must be defined.");
        url_ = url_.replace("{modifier}", encodeURIComponent("" + modifier));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetFavori(_response);
        });
    }

    protected processSetFavori(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBackgroundJobsClient {

    /**
     * Créer un job récurrent (avec la récurrence cron) qui permet de supprimer les WorkflowContext du serveur de context    ///
     * @param body (optional) 
     * @return OK
     */
    startRecurringTraces(body?: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class BackgroundJobsClient extends AuthorizedApiBase implements IBackgroundJobsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Créer un job récurrent (avec la récurrence cron) qui permet de supprimer les WorkflowContext du serveur de context    ///
     * @param body (optional) 
     * @return OK
     */
    startRecurringTraces(body?: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/jobs/background/clean/context/workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartRecurringTraces(_response);
        });
    }

    protected processStartRecurringTraces(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IConfigClient {

    /**
     * Récupère tous les types de pièces jointes avec leur catégorie
     * @return OK
     */
    getAllTypesPieces( cancelToken?: CancelToken): Promise<TypePieceWithCategorie[]>;

    /**
     * @return OK
     */
    getConfigurationFront( cancelToken?: CancelToken): Promise<IConfigurationFront>;

    /**
     * @return OK
     */
    getConfigurationMobile( cancelToken?: CancelToken): Promise<IConfigurationMobile>;

    /**
     * @return OK
     */
    getConfigurationBureau( cancelToken?: CancelToken): Promise<IConfigurationBureau>;

    /**
     * @return OK
     */
    getConfigurationTelemetry( cancelToken?: CancelToken): Promise<void>;
}

export class ConfigClient extends AuthorizedApiBase implements IConfigClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère tous les types de pièces jointes avec leur catégorie
     * @return OK
     */
    getAllTypesPieces(): Promise<TypePieceWithCategorie[]> {
        let url_ = this.baseUrl + "/api/v2/configs/types-pieces";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllTypesPieces(_response);
        });
    }

    protected processGetAllTypesPieces(response: Response): Promise<TypePieceWithCategorie[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TypePieceWithCategorie[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TypePieceWithCategorie[]>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationFront(): Promise<IConfigurationFront> {
        let url_ = this.baseUrl + "/api/v2/configs/front";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationFront(_response);
        });
    }

    protected processGetConfigurationFront(response: Response): Promise<IConfigurationFront> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationFront;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationFront>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationMobile(): Promise<IConfigurationMobile> {
        let url_ = this.baseUrl + "/api/v2/configs/mobile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationMobile(_response);
        });
    }

    protected processGetConfigurationMobile(response: Response): Promise<IConfigurationMobile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationMobile;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationMobile>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationBureau(): Promise<IConfigurationBureau> {
        let url_ = this.baseUrl + "/api/v2/configs/bureau";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationBureau(_response);
        });
    }

    protected processGetConfigurationBureau(response: Response): Promise<IConfigurationBureau> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IConfigurationBureau;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IConfigurationBureau>(null as any);
    }

    /**
     * @return OK
     */
    getConfigurationTelemetry(): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/configs/telemetry";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConfigurationTelemetry(_response);
        });
    }

    protected processGetConfigurationTelemetry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IConversationClient {

    /**
     * Récupération des conversations d'un ou plusieurs PS cible
     * @param body (optional) 
     * @return OK
     */
    getConversations(body?: GetConversationsRequestV2 | undefined,  cancelToken?: CancelToken): Promise<GetConversationsResponse>;

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param emailMssPsIdentifie (optional) 
     * @param type (optional) 
     * @param marquerCommeLu (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param search (optional) 
     * @return OK
     */
    getDetailConversation(idTechPsIdentifie: string, idConversation: string, source: ConversationSource, emailMssPsIdentifie?: string | undefined, type?: ConversationType | undefined, marquerCommeLu?: boolean | undefined, pageSize?: number | undefined, pageIndex?: number | undefined, search?: string | undefined,  cancelToken?: CancelToken): Promise<ConversationDetail>;

    /**
     * Récupère les métadonnées des documents de la conversation (Libelle / IdLocalDoc / IdEts...)
     * @param idConversation Identifiant de la conversation
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @return OK
     */
    getListeDocumentsByConversationId(idTechPsIdentifie: string, idConversation: string, type: ConversationType, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined,  cancelToken?: CancelToken): Promise<WebmailMessageDocument[]>;

    /**
     * Récupère le nombre de conversations non lus pour un tech PS par type de conversation
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    countConversationNonLues(body?: InfoPsIdentifie[] | undefined,  cancelToken?: CancelToken): Promise<Anonymous>;

    /**
     * Permet d'envoyer un message dans une conversation au nom de l'auteur spécifié en paramètre. Un fichier peut être envoyé avec le message dans la conversation.
     * @param body (optional) Données nécessaires à l'ajout d'un message dans une conversation
     * @return Identifiant du message créé.
     */
    addMessageToConversation(idConversation: string, source: ConversationSource, body?: AddMessageToConversationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<number>;

    /**
     * Quitter la conversation (Mettre à jour la date de fin de participation)
     * @param body (optional) Contient les données nécessaires pour qu'un PS puisse quitter une conversation
     * @return OK
     */
    leaveConversation(idConversation: string, source: ConversationSource, body?: LeaveConversationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return Id de la room créée
     * @deprecated
     */
    startVisio(idConversation: string, source: ConversationSource, body?: StartVisioRequestV2 | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Permet de mettre à jour le statut d'une conversation pour un utilisateur
     * @param body (optional) Requête contenant les statuts de la conversation à mettre à jour
     * @return OK
     */
    updateStatusConversation(idConversation: string, source: ConversationSource, body?: UpdateStatutConversationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Récupere le detail et le light d'un conversationId
     * @param emailMssPsIdentifie (optional) 
     * @param type (optional) 
     * @param marquerCommeLu (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param search (optional) 
     * @return OK
     */
    getConversationFromContext(idTechPsIdentifie: string, idConversation: string, source: ConversationSource, emailMssPsIdentifie?: string | undefined, type?: ConversationType | undefined, marquerCommeLu?: boolean | undefined, pageSize?: number | undefined, pageIndex?: number | undefined, search?: string | undefined,  cancelToken?: CancelToken): Promise<FullConversation>;

    /**
     * Récupere les messages d'un conversation
     * @return OK
     */
    getMessages(idConversation: string, source: ConversationSource, idTechPsIdentifie: string, pageIndex: number, pageSize: number,  cancelToken?: CancelToken): Promise<MessagesDestinatairesConversation>;

    /**
     * Marque toutes les conversations de l'utilisateur comme lues/archivées
     * @param body (optional) 
     * @return No Content
     */
    updateStatusConversations(body?: UpdateConversationsStatusRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Télécharge la synthèse des téléexpertises de l'utilisateur identifié
     * @param idsTechPsList Les identifiants des PS pour qui on va faire l'export TLE
     * @return OK
     */
    downloadTeleExpertiseReport(idsTechPsList: string[],  cancelToken?: CancelToken): Promise<FileResponse>;

    /**
     * Ajoute des destinataires a une conversation
     * @param body (optional) 
     * @return OK
     */
    addDestinataires(idConversation: string, source: ConversationSource, body?: AddDestinatairesRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReaction(idEchange: string, idConversation: string, modifier: UpdateEmojiModifier, body?: UpdateReactionRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Récupère l'idTech du premier delegant commun à une liste de delegants et aux membres d'une conversation
     * @return OK
     */
    getFirstIdTechDelegantFromConversation(idConversation: string,  cancelToken?: CancelToken): Promise<string>;
}

export class ConversationClient extends AuthorizedApiBase implements IConversationClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupération des conversations d'un ou plusieurs PS cible
     * @param body (optional) 
     * @return OK
     */
    getConversations(body?: GetConversationsRequestV2 | undefined): Promise<GetConversationsResponse> {
        let url_ = this.baseUrl + "/api/v2/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConversations(_response);
        });
    }

    protected processGetConversations(response: Response): Promise<GetConversationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetConversationsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationsResponse>(null as any);
    }

    /**
     * Récupère le détail d'une conversation : liste des échanges, destinataires, ...
     * @param emailMssPsIdentifie (optional) 
     * @param type (optional) 
     * @param marquerCommeLu (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param search (optional) 
     * @return OK
     */
    getDetailConversation(idTechPsIdentifie: string, idConversation: string, source: ConversationSource, emailMssPsIdentifie?: string | undefined, type?: ConversationType | undefined, marquerCommeLu?: boolean | undefined, pageSize?: number | undefined, pageIndex?: number | undefined, search?: string | undefined): Promise<ConversationDetail> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (emailMssPsIdentifie === null)
            throw new globalThis.Error("The parameter 'emailMssPsIdentifie' cannot be null.");
        else if (emailMssPsIdentifie !== undefined)
            url_ += "emailMssPsIdentifie=" + encodeURIComponent("" + emailMssPsIdentifie) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (marquerCommeLu === null)
            throw new globalThis.Error("The parameter 'marquerCommeLu' cannot be null.");
        else if (marquerCommeLu !== undefined)
            url_ += "marquerCommeLu=" + encodeURIComponent("" + marquerCommeLu) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDetailConversation(_response);
        });
    }

    protected processGetDetailConversation(response: Response): Promise<ConversationDetail> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ConversationDetail;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationDetail>(null as any);
    }

    /**
     * Récupère les métadonnées des documents de la conversation (Libelle / IdLocalDoc / IdEts...)
     * @param idConversation Identifiant de la conversation
     * @param emailMssPsIdentifie (optional) 
     * @param source (optional) 
     * @return OK
     */
    getListeDocumentsByConversationId(idTechPsIdentifie: string, idConversation: string, type: ConversationType, emailMssPsIdentifie?: string | undefined, source?: ConversationSource | undefined): Promise<WebmailMessageDocument[]> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/documents?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source !== null && source !== undefined)
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        else
            url_ = url_.replace("/{source}", "");
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined and cannot be null.");
        else
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (emailMssPsIdentifie === null)
            throw new globalThis.Error("The parameter 'emailMssPsIdentifie' cannot be null.");
        else if (emailMssPsIdentifie !== undefined)
            url_ += "emailMssPsIdentifie=" + encodeURIComponent("" + emailMssPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetListeDocumentsByConversationId(_response);
        });
    }

    protected processGetListeDocumentsByConversationId(response: Response): Promise<WebmailMessageDocument[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WebmailMessageDocument[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WebmailMessageDocument[]>(null as any);
    }

    /**
     * Récupère le nombre de conversations non lus pour un tech PS par type de conversation
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    countConversationNonLues(body?: InfoPsIdentifie[] | undefined): Promise<Anonymous> {
        let url_ = this.baseUrl + "/api/v2/conversations/non-lues/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountConversationNonLues(_response);
        });
    }

    protected processCountConversationNonLues(response: Response): Promise<Anonymous> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous>(null as any);
    }

    /**
     * Permet d'envoyer un message dans une conversation au nom de l'auteur spécifié en paramètre. Un fichier peut être envoyé avec le message dans la conversation.
     * @param body (optional) Données nécessaires à l'ajout d'un message dans une conversation
     * @return Identifiant du message créé.
     */
    addMessageToConversation(idConversation: string, source: ConversationSource, body?: AddMessageToConversationRequestV2 | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/add-message";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddMessageToConversation(_response);
        });
    }

    protected processAddMessageToConversation(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Quitter la conversation (Mettre à jour la date de fin de participation)
     * @param body (optional) Contient les données nécessaires pour qu'un PS puisse quitter une conversation
     * @return OK
     */
    leaveConversation(idConversation: string, source: ConversationSource, body?: LeaveConversationRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/quitter";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLeaveConversation(_response);
        });
    }

    protected processLeaveConversation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return Id de la room créée
     * @deprecated
     */
    startVisio(idConversation: string, source: ConversationSource, body?: StartVisioRequestV2 | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/start-visio";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartVisio(_response);
        });
    }

    protected processStartVisio(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Permet de mettre à jour le statut d'une conversation pour un utilisateur
     * @param body (optional) Requête contenant les statuts de la conversation à mettre à jour
     * @return OK
     */
    updateStatusConversation(idConversation: string, source: ConversationSource, body?: UpdateStatutConversationRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/status";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatusConversation(_response);
        });
    }

    protected processUpdateStatusConversation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Récupere le detail et le light d'un conversationId
     * @param emailMssPsIdentifie (optional) 
     * @param type (optional) 
     * @param marquerCommeLu (optional) 
     * @param pageSize (optional) 
     * @param pageIndex (optional) 
     * @param search (optional) 
     * @return OK
     */
    getConversationFromContext(idTechPsIdentifie: string, idConversation: string, source: ConversationSource, emailMssPsIdentifie?: string | undefined, type?: ConversationType | undefined, marquerCommeLu?: boolean | undefined, pageSize?: number | undefined, pageIndex?: number | undefined, search?: string | undefined): Promise<FullConversation> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/full?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (emailMssPsIdentifie === null)
            throw new globalThis.Error("The parameter 'emailMssPsIdentifie' cannot be null.");
        else if (emailMssPsIdentifie !== undefined)
            url_ += "emailMssPsIdentifie=" + encodeURIComponent("" + emailMssPsIdentifie) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (marquerCommeLu === null)
            throw new globalThis.Error("The parameter 'marquerCommeLu' cannot be null.");
        else if (marquerCommeLu !== undefined)
            url_ += "marquerCommeLu=" + encodeURIComponent("" + marquerCommeLu) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConversationFromContext(_response);
        });
    }

    protected processGetConversationFromContext(response: Response): Promise<FullConversation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullConversation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullConversation>(null as any);
    }

    /**
     * Récupere les messages d'un conversation
     * @return OK
     */
    getMessages(idConversation: string, source: ConversationSource, idTechPsIdentifie: string, pageIndex: number, pageSize: number): Promise<MessagesDestinatairesConversation> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/message/{pageIndex}?";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (pageIndex === undefined || pageIndex === null)
            throw new globalThis.Error("The parameter 'pageIndex' must be defined.");
        url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        if (pageSize === undefined || pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' must be defined and cannot be null.");
        else
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMessages(_response);
        });
    }

    protected processGetMessages(response: Response): Promise<MessagesDestinatairesConversation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MessagesDestinatairesConversation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MessagesDestinatairesConversation>(null as any);
    }

    /**
     * Marque toutes les conversations de l'utilisateur comme lues/archivées
     * @param body (optional) 
     * @return No Content
     */
    updateStatusConversations(body?: UpdateConversationsStatusRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversations/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatusConversations(_response);
        });
    }

    protected processUpdateStatusConversations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Télécharge la synthèse des téléexpertises de l'utilisateur identifié
     * @param idsTechPsList Les identifiants des PS pour qui on va faire l'export TLE
     * @return OK
     */
    downloadTeleExpertiseReport(idsTechPsList: string[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v2/conversations/teleexpertise-report?";
        if (idsTechPsList === undefined || idsTechPsList === null)
            throw new globalThis.Error("The parameter 'idsTechPsList' must be defined and cannot be null.");
        else
            idsTechPsList && idsTechPsList.forEach(item => { url_ += "idsTechPsList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadTeleExpertiseReport(_response);
        });
    }

    protected processDownloadTeleExpertiseReport(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Ajoute des destinataires a une conversation
     * @param body (optional) 
     * @return OK
     */
    addDestinataires(idConversation: string, source: ConversationSource, body?: AddDestinatairesRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversations/{source}/{idConversation}/destinataires";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddDestinataires(_response);
        });
    }

    protected processAddDestinataires(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateReaction(idEchange: string, idConversation: string, modifier: UpdateEmojiModifier, body?: UpdateReactionRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/conversations/{idConversation}/{idEchange}/reaction/{modifier}";
        if (idEchange === undefined || idEchange === null)
            throw new globalThis.Error("The parameter 'idEchange' must be defined.");
        url_ = url_.replace("{idEchange}", encodeURIComponent("" + idEchange));
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (modifier === undefined || modifier === null)
            throw new globalThis.Error("The parameter 'modifier' must be defined.");
        url_ = url_.replace("{modifier}", encodeURIComponent("" + modifier));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateReaction(_response);
        });
    }

    protected processUpdateReaction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Récupère l'idTech du premier delegant commun à une liste de delegants et aux membres d'une conversation
     * @return OK
     */
    getFirstIdTechDelegantFromConversation(idConversation: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/conversations/{idConversation}/first-delegant";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFirstIdTechDelegantFromConversation(_response);
        });
    }

    protected processGetFirstIdTechDelegantFromConversation(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IDocumentClient {

    /**
     * Récupère les documents de plusieurs conversation en même temps
     * @param body (optional) 
     * @return OK
     */
    getManyConversationsDocuments(body?: GetConversationDocumentRequest[] | undefined,  cancelToken?: CancelToken): Promise<{ [key: string]: WebmailMessageDocument[]; }>;

    /**
     * Permet de renvoyer une liste de documents au format donné
     * @param body (optional) 
     * @return Contenu binaire des documents au format souhaité
     */
    getManyDocsWithSameFormat(body?: GetManyDocsWithSameFormatRequest | undefined,  cancelToken?: CancelToken): Promise<MultiDoc[]>;
}

export class DocumentClient extends AuthorizedApiBase implements IDocumentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère les documents de plusieurs conversation en même temps
     * @param body (optional) 
     * @return OK
     */
    getManyConversationsDocuments(body?: GetConversationDocumentRequest[] | undefined): Promise<{ [key: string]: WebmailMessageDocument[]; }> {
        let url_ = this.baseUrl + "/api/v2/documents/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyConversationsDocuments(_response);
        });
    }

    protected processGetManyConversationsDocuments(response: Response): Promise<{ [key: string]: WebmailMessageDocument[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: WebmailMessageDocument[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: WebmailMessageDocument[]; }>(null as any);
    }

    /**
     * Permet de renvoyer une liste de documents au format donné
     * @param body (optional) 
     * @return Contenu binaire des documents au format souhaité
     */
    getManyDocsWithSameFormat(body?: GetManyDocsWithSameFormatRequest | undefined): Promise<MultiDoc[]> {
        let url_ = this.baseUrl + "/api/v2/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetManyDocsWithSameFormat(_response);
        });
    }

    protected processGetManyDocsWithSameFormat(response: Response): Promise<MultiDoc[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MultiDoc[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultiDoc[]>(null as any);
    }
}

export interface IEnrollmentClient {

    /**
     * Permet de savoir si le mot de passe est celui de son compte SARA
     * @param idTechPs Id technique du PS
     * @param password Mot de passe du PS (en clair)
     * @return OK
     */
    isPasswordValid(idTechPs: string, password: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Permet de savoir si le login est déjà utilisé
     * @return OK
     */
    doesAccountExists(login: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Permet de modifier le mot de passe et le login du compte SARA
     * @return Le compte a été configuré
     */
    setAccountCredentials(body: SetAccountCredentialsRequest,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Génère un refresh token (JWT) pour l'utilisateur connecté. (Keycloak uniquement)
     * @return OK
     */
    generateRefreshJwtToken( cancelToken?: CancelToken): Promise<string>;
}

export class EnrollmentClient extends AuthorizedApiBase implements IEnrollmentClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Permet de savoir si le mot de passe est celui de son compte SARA
     * @param idTechPs Id technique du PS
     * @param password Mot de passe du PS (en clair)
     * @return OK
     */
    isPasswordValid(idTechPs: string, password: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v2/enrollment/password/valid?";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined and cannot be null.");
        else
            url_ += "idTechPs=" + encodeURIComponent("" + idTechPs) + "&";
        if (password === undefined || password === null)
            throw new globalThis.Error("The parameter 'password' must be defined and cannot be null.");
        else
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIsPasswordValid(_response);
        });
    }

    protected processIsPasswordValid(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Permet de savoir si le login est déjà utilisé
     * @return OK
     */
    doesAccountExists(login: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v2/enrollment/account/{login}/exists";
        if (login === undefined || login === null)
            throw new globalThis.Error("The parameter 'login' must be defined.");
        url_ = url_.replace("{login}", encodeURIComponent("" + login));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDoesAccountExists(_response);
        });
    }

    protected processDoesAccountExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Permet de modifier le mot de passe et le login du compte SARA
     * @return Le compte a été configuré
     */
    setAccountCredentials(body: SetAccountCredentialsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/enrollment/account/setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAccountCredentials(_response);
        });
    }

    protected processSetAccountCredentials(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Le mot de passe ne respect pas la politique de s\u00e9curit\u00e9", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Génère un refresh token (JWT) pour l'utilisateur connecté. (Keycloak uniquement)
     * @return OK
     */
    generateRefreshJwtToken(): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/enrollment/jwt/refresh-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGenerateRefreshJwtToken(_response);
        });
    }

    protected processGenerateRefreshJwtToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IFichierTravailClient {

    /**
     * Création d’un document de travail lors de l’ajout d’une pièce jointe
     * @param idDocumentTravail Identifiant du document travail
     * @param source Source du document travail
     * @param idType (optional) 
     * @param idLocalDoc (optional) Id local du document a conserver
     * @param idEts (optional) Id de l'etablissement
     * @param file (optional) 
     * @return Created
     */
    createFichierTravail(idDocumentTravail: string, source: ConversationSource, idType?: number | undefined, idLocalDoc?: string | undefined, idEts?: number | undefined, file?: FileParameter | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Création d’un document de travail avec une piece jointe existante
     * @param body (optional) 
     * @return Created
     */
    createFichierTravailWithExistingPiece(body?: CreateExistingFichierTravailRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Mise a jour du type d'un fichier travail
     * @param body (optional) 
     * @return No Content
     */
    updateFichierTravailType(source: ConversationSource, idFichierTravail: string, body?: number | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Mise a jour de la date d'un fichier travail
     * @param body (optional) 
     * @return No Content
     */
    updateFichierTravailDate(source: ConversationSource, idFichierTravail: string, body?: Date | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Supprime un document de travail via son id
     * @return No Content
     */
    deleteFichierTravail(idFichierTravail: string, source: ConversationSource,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Création d’un fichier de travail à partir d'un fichier dans le serveur de contexte
     * @param body (optional) 
     * @return Created
     */
    createFichierTravailFromContext(body?: CreateFichierTravailFromContextRequest | undefined,  cancelToken?: CancelToken): Promise<string>;
}

export class FichierTravailClient extends AuthorizedApiBase implements IFichierTravailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Création d’un document de travail lors de l’ajout d’une pièce jointe
     * @param idDocumentTravail Identifiant du document travail
     * @param source Source du document travail
     * @param idType (optional) 
     * @param idLocalDoc (optional) Id local du document a conserver
     * @param idEts (optional) Id de l'etablissement
     * @param file (optional) 
     * @return Created
     */
    createFichierTravail(idDocumentTravail: string, source: ConversationSource, idType?: number | undefined, idLocalDoc?: string | undefined, idEts?: number | undefined, file?: FileParameter | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail?";
        if (idDocumentTravail === undefined || idDocumentTravail === null)
            throw new globalThis.Error("The parameter 'idDocumentTravail' must be defined and cannot be null.");
        else
            url_ += "idDocumentTravail=" + encodeURIComponent("" + idDocumentTravail) + "&";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined and cannot be null.");
        else
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (idType === null)
            throw new globalThis.Error("The parameter 'idType' cannot be null.");
        else if (idType !== undefined)
            url_ += "idType=" + encodeURIComponent("" + idType) + "&";
        if (idLocalDoc === null)
            throw new globalThis.Error("The parameter 'idLocalDoc' cannot be null.");
        else if (idLocalDoc !== undefined)
            url_ += "idLocalDoc=" + encodeURIComponent("" + idLocalDoc) + "&";
        if (idEts === null)
            throw new globalThis.Error("The parameter 'idEts' cannot be null.");
        else if (idEts !== undefined)
            url_ += "idEts=" + encodeURIComponent("" + idEts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFichierTravail(_response);
        });
    }

    protected processCreateFichierTravail(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : _responseText as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Création d’un document de travail avec une piece jointe existante
     * @param body (optional) 
     * @return Created
     */
    createFichierTravailWithExistingPiece(body?: CreateExistingFichierTravailRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail/existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFichierTravailWithExistingPiece(_response);
        });
    }

    protected processCreateFichierTravailWithExistingPiece(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : _responseText as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Mise a jour du type d'un fichier travail
     * @param body (optional) 
     * @return No Content
     */
    updateFichierTravailType(source: ConversationSource, idFichierTravail: string, body?: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail/{source}/{idFichierTravail}/type";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (idFichierTravail === undefined || idFichierTravail === null)
            throw new globalThis.Error("The parameter 'idFichierTravail' must be defined.");
        url_ = url_.replace("{idFichierTravail}", encodeURIComponent("" + idFichierTravail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFichierTravailType(_response);
        });
    }

    protected processUpdateFichierTravailType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Mise a jour de la date d'un fichier travail
     * @param body (optional) 
     * @return No Content
     */
    updateFichierTravailDate(source: ConversationSource, idFichierTravail: string, body?: Date | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail/{source}/{idFichierTravail}/date";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        if (idFichierTravail === undefined || idFichierTravail === null)
            throw new globalThis.Error("The parameter 'idFichierTravail' must be defined.");
        url_ = url_.replace("{idFichierTravail}", encodeURIComponent("" + idFichierTravail));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFichierTravailDate(_response);
        });
    }

    protected processUpdateFichierTravailDate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supprime un document de travail via son id
     * @return No Content
     */
    deleteFichierTravail(idFichierTravail: string, source: ConversationSource): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail/{source}/{idFichierTravail}";
        if (idFichierTravail === undefined || idFichierTravail === null)
            throw new globalThis.Error("The parameter 'idFichierTravail' must be defined.");
        url_ = url_.replace("{idFichierTravail}", encodeURIComponent("" + idFichierTravail));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFichierTravail(_response);
        });
    }

    protected processDeleteFichierTravail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Création d’un fichier de travail à partir d'un fichier dans le serveur de contexte
     * @param body (optional) 
     * @return Created
     */
    createFichierTravailFromContext(body?: CreateFichierTravailFromContextRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/fichiers-travail/context";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFichierTravailFromContext(_response);
        });
    }

    protected processCreateFichierTravailFromContext(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : _responseText as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IMailClient {

    /**
     * @param body (optional) 
     * @return OK
     */
    getMails(body?: GetConversationsRequestV2 | undefined,  cancelToken?: CancelToken): Promise<GetConversationsResponse>;

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMail(idConversation: string, source: ConversationSource, body?: UpdateStatutConversationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMails(body?: UpdateConversationsStatusRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Récupère le nombre de non lus pour les mails MssSaraV2
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    countMailNonLus(body?: InfoPsIdentifie[] | undefined,  cancelToken?: CancelToken): Promise<Anonymous2>;
}

export class MailClient extends AuthorizedApiBase implements IMailClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    getMails(body?: GetConversationsRequestV2 | undefined): Promise<GetConversationsResponse> {
        let url_ = this.baseUrl + "/api/v2/mails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMails(_response);
        });
    }

    protected processGetMails(response: Response): Promise<GetConversationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetConversationsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationsResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMail(idConversation: string, source: ConversationSource, body?: UpdateStatutConversationRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/mails/{source}/{idConversation}/status";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMail(_response);
        });
    }

    protected processUpdateMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMails(body?: UpdateConversationsStatusRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/mails/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMails(_response);
        });
    }

    protected processUpdateMails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Récupère le nombre de non lus pour les mails MssSaraV2
     * @param body (optional) 
     * @return OK
     * @deprecated
     */
    countMailNonLus(body?: InfoPsIdentifie[] | undefined): Promise<Anonymous2> {
        let url_ = this.baseUrl + "/api/v2/mails/non-lus/count";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountMailNonLus(_response);
        });
    }

    protected processCountMailNonLus(response: Response): Promise<Anonymous2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Anonymous2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Anonymous2>(null as any);
    }
}

export interface IMenuClient {

    /**
     * Met à jour le menu d'un PS
     * @param body (optional) 
     * @return No Content
     */
    updateMenuByIdTechPs(body?: MenuMessagerie | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Compte les mails non lus par status (archivée, etc.) pour chaque ps
     * @param body (optional) 
     * @return OK
     */
    countMailsNonLusByStatusAndPs(body?: InfoPsIdentifie[] | undefined,  cancelToken?: CancelToken): Promise<CountMailNonLusByTypeAndPsResponse>;

    /**
     * Compte les conversations non lus par status (archivée, etc.) pour chaque type de conversation et ps
     * @param body (optional) 
     * @return OK
     */
    countConversationNonLusByTypeAndPs(body?: string[] | undefined,  cancelToken?: CancelToken): Promise<CountConversationNonLusByTypeAndPsResponse>;
}

export class MenuClient extends AuthorizedApiBase implements IMenuClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Met à jour le menu d'un PS
     * @param body (optional) 
     * @return No Content
     */
    updateMenuByIdTechPs(body?: MenuMessagerie | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/menus/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMenuByIdTechPs(_response);
        });
    }

    protected processUpdateMenuByIdTechPs(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Compte les mails non lus par status (archivée, etc.) pour chaque ps
     * @param body (optional) 
     * @return OK
     */
    countMailsNonLusByStatusAndPs(body?: InfoPsIdentifie[] | undefined): Promise<CountMailNonLusByTypeAndPsResponse> {
        let url_ = this.baseUrl + "/api/v2/menus/non-lus/mails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountMailsNonLusByStatusAndPs(_response);
        });
    }

    protected processCountMailsNonLusByStatusAndPs(response: Response): Promise<CountMailNonLusByTypeAndPsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountMailNonLusByTypeAndPsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountMailNonLusByTypeAndPsResponse>(null as any);
    }

    /**
     * Compte les conversations non lus par status (archivée, etc.) pour chaque type de conversation et ps
     * @param body (optional) 
     * @return OK
     */
    countConversationNonLusByTypeAndPs(body?: string[] | undefined): Promise<CountConversationNonLusByTypeAndPsResponse> {
        let url_ = this.baseUrl + "/api/v2/menus/non-lus/conversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCountConversationNonLusByTypeAndPs(_response);
        });
    }

    protected processCountConversationNonLusByTypeAndPs(response: Response): Promise<CountConversationNonLusByTypeAndPsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountConversationNonLusByTypeAndPsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountConversationNonLusByTypeAndPsResponse>(null as any);
    }
}

export interface IPatientsClient {

    /**
     * Retourne la liste des patients suivis et les derniers consultés par le PS
     * @return OK
     */
    getPatientsParPS(idTechPsCible: string,  cancelToken?: CancelToken): Promise<GetPatientsParPS>;

    /**
     * Retourne si le patient à un compte MaSantéConnectée
     * @param ippr Identfiant du patient
     * @return OK
     */
    verifyMscAccount(ippr: string,  cancelToken?: CancelToken): Promise<boolean>;

    /**
     * Retourne le patient stic light via son ippr
     * @param ippr Identfiant du patient
     * @return OK
     */
    getPatientLight(ippr: number,  cancelToken?: CancelToken): Promise<PatientLight>;
}

export class PatientsClient extends AuthorizedApiBase implements IPatientsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Retourne la liste des patients suivis et les derniers consultés par le PS
     * @return OK
     */
    getPatientsParPS(idTechPsCible: string): Promise<GetPatientsParPS> {
        let url_ = this.baseUrl + "/api/v2/patients?";
        if (idTechPsCible === undefined || idTechPsCible === null)
            throw new globalThis.Error("The parameter 'idTechPsCible' must be defined and cannot be null.");
        else
            url_ += "idTechPsCible=" + encodeURIComponent("" + idTechPsCible) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatientsParPS(_response);
        });
    }

    protected processGetPatientsParPS(response: Response): Promise<GetPatientsParPS> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetPatientsParPS;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetPatientsParPS>(null as any);
    }

    /**
     * Retourne si le patient à un compte MaSantéConnectée
     * @param ippr Identfiant du patient
     * @return OK
     */
    verifyMscAccount(ippr: string): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v2/patients/{ippr}/msc-account";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined.");
        url_ = url_.replace("{ippr}", encodeURIComponent("" + ippr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyMscAccount(_response);
        });
    }

    protected processVerifyMscAccount(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * Retourne le patient stic light via son ippr
     * @param ippr Identfiant du patient
     * @return OK
     */
    getPatientLight(ippr: number): Promise<PatientLight> {
        let url_ = this.baseUrl + "/api/v2/patients/{ippr}/light";
        if (ippr === undefined || ippr === null)
            throw new globalThis.Error("The parameter 'ippr' must be defined.");
        url_ = url_.replace("{ippr}", encodeURIComponent("" + ippr));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPatientLight(_response);
        });
    }

    protected processGetPatientLight(response: Response): Promise<PatientLight> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PatientLight;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PatientLight>(null as any);
    }
}

export interface IProfessionnelClient {

    /**
     * Récupère les infos d'un patient suivi par le PS identifié
     * @return OK
     */
    getFileActive(idTechPs: string,  cancelToken?: CancelToken): Promise<string[]>;

    /**
     * Modifie le status de file active
     * @param body (optional) 
     * @return No Content
     */
    updateFileActiveStatus(idTechPs: string, body?: UpdateFileActiveStatusRequestV2 | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Retrouve les infos du PS connecté, ainsi que la liste de ses délégants afin qu'il puisse choisir son idTechPsIdentifie
     * @return OK
     */
    getInformationsPSConnecte( cancelToken?: CancelToken): Promise<UserInfoV2>;

    /**
     * Set le statut absent du PS
     * @param body (optional) 
     * @return OK
     */
    setAbsence(idTechPs: string, body?: SetAbsenceRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Supprime le statut absent du PS
     * @return OK
     */
    removeAbsence(idTechPs: string,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Set le statut absent du PS
     * @return OK
     */
    getByIdTech(idTechPs: string,  cancelToken?: CancelToken): Promise<UserInfo>;

    /**
     * Récupère les favoris du ps identifie en prenant en compte les filtres
     * @param body (optional) 
     * @return OK
     */
    getFavoris(idTechPs: string, body?: GetFavorisRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Récupère les ps recents du ps identifie en prenant en compte les filtres
     * @param body (optional) 
     * @return OK
     */
    getRecents(idTechPs: string, body?: GetRecentsRequest | undefined,  cancelToken?: CancelToken): Promise<PPAndServices>;

    /**
     * Récupère les informations du ps connecté en incluant les droits, les informations de statut et le menu
     * @return OK
     */
    getInformationsPSMonSisraConnecte( cancelToken?: CancelToken): Promise<PsMonSisra>;

    /**
     * Récupère le nom, la profession et la spécialité d'un ps
     * @return OK
     */
    getUserProfessionSpecialite(idTechPs: string,  cancelToken?: CancelToken): Promise<UserProfessionSpecialite>;
    /**
     * Permet de récupérer les données profession + spécialité + pec utiles pour les filtres du module de recherche en mode OP
     * @return Filtres pour le module de recherche de l'Annuaire OP
     */
    getFiltresModuleRechercheOP(): Promise<ModuleRechercheOPFilters>;
}

export class ProfessionnelClient extends AuthorizedApiBase implements IProfessionnelClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère les infos d'un patient suivi par le PS identifié
     * @return OK
     */
    getFileActive(idTechPs: string): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/file-active";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileActive(_response);
        });
    }

    protected processGetFileActive(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * Modifie le status de file active
     * @param body (optional) 
     * @return No Content
     */
    updateFileActiveStatus(idTechPs: string, body?: UpdateFileActiveStatusRequestV2 | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/file-active";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateFileActiveStatus(_response);
        });
    }

    protected processUpdateFileActiveStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrouve les infos du PS connecté, ainsi que la liste de ses délégants afin qu'il puisse choisir son idTechPsIdentifie
     * @return OK
     */
    getInformationsPSConnecte(): Promise<UserInfoV2> {
        let url_ = this.baseUrl + "/api/v2/professionnels/connecte";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationsPSConnecte(_response);
        });
    }

    protected processGetInformationsPSConnecte(response: Response): Promise<UserInfoV2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoV2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoV2>(null as any);
    }

    /**
     * Set le statut absent du PS
     * @param body (optional) 
     * @return OK
     */
    setAbsence(idTechPs: string, body?: SetAbsenceRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/absence";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAbsence(_response);
        });
    }

    protected processSetAbsence(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supprime le statut absent du PS
     * @return OK
     */
    removeAbsence(idTechPs: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/absence";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveAbsence(_response);
        });
    }

    protected processRemoveAbsence(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set le statut absent du PS
     * @return OK
     */
    getByIdTech(idTechPs: string): Promise<UserInfo> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByIdTech(_response);
        });
    }

    protected processGetByIdTech(response: Response): Promise<UserInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfo;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfo>(null as any);
    }

    /**
     * Récupère les favoris du ps identifie en prenant en compte les filtres
     * @param body (optional) 
     * @return OK
     */
    getFavoris(idTechPs: string, body?: GetFavorisRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/favoris";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFavoris(_response);
        });
    }

    protected processGetFavoris(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Récupère les ps recents du ps identifie en prenant en compte les filtres
     * @param body (optional) 
     * @return OK
     */
    getRecents(idTechPs: string, body?: GetRecentsRequest | undefined): Promise<PPAndServices> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/recents";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecents(_response);
        });
    }

    protected processGetRecents(response: Response): Promise<PPAndServices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PPAndServices;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PPAndServices>(null as any);
    }

    /**
     * Récupère les informations du ps connecté en incluant les droits, les informations de statut et le menu
     * @return OK
     */
    getInformationsPSMonSisraConnecte(): Promise<PsMonSisra> {
        let url_ = this.baseUrl + "/api/v2/professionnels/ps-connecte";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInformationsPSMonSisraConnecte(_response);
        });
    }

    protected processGetInformationsPSMonSisraConnecte(response: Response): Promise<PsMonSisra> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PsMonSisra;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PsMonSisra>(null as any);
    }

    /**
     * Récupère le nom, la profession et la spécialité d'un ps
     * @return OK
     */
    getUserProfessionSpecialite(idTechPs: string): Promise<UserProfessionSpecialite> {
        let url_ = this.baseUrl + "/api/v2/professionnels/{idTechPs}/profession";
        if (idTechPs === undefined || idTechPs === null)
            throw new globalThis.Error("The parameter 'idTechPs' must be defined.");
        url_ = url_.replace("{idTechPs}", encodeURIComponent("" + idTechPs));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserProfessionSpecialite(_response);
        });
    }

    protected processGetUserProfessionSpecialite(response: Response): Promise<UserProfessionSpecialite> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfessionSpecialite;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserProfessionSpecialite>(null as any);
    }

    /**
     * Permet de récupérer les données profession + spécialité + pec utiles pour les filtres du module de recherche en mode OP
     * @return Filtres pour le module de recherche de l'Annuaire OP
     */
    getFiltresModuleRechercheOP(): Promise<ModuleRechercheOPFilters> {
        let url_ = this.baseUrl + "/api/v2/professionnels/filtres-metier-op";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFiltresModuleRechercheOP(_response);
        });
    }

    protected processGetFiltresModuleRechercheOP(response: Response): Promise<ModuleRechercheOPFilters> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModuleRechercheOPFilters;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModuleRechercheOPFilters>(null as any);
    }
}

export interface ISollicitationsClient {

    /**
     * Génére un échange contenant la synthèse de la conversation a partir de l'idDocument du formulaire
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversationTLE(body?: SyntheseConversationTLEWithIdDocRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Met à jour le statut d'une téléexpertise vers MonSisra.Api.Abstractions.Transport.Enum.EtatSollicitation.EnCours
     * @param body (optional) 
     * @return No Content
     */
    startSollicitation(body?: StartSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Récupération des sollicitations (TLE ou demande d'appui) d'un ou plusieurs PS cible
     * @param body (optional) 
     * @return OK
     */
    getSollicitations(body?: GetSollicitationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<GetConversationsResponse>;

    /**
     * Permet de modifier l'etat d'une sollicitation
     * @param idConversation Identifiant de la conversation
     * @param etat Nouvel etat de la sollicitation
     * @param body (optional) Données nécessaires pour changer le statut de la sollicitation
     * @return OK
     */
    setEtatSollicitation(idConversation: string, etat: EtatSollicitation, body?: SetEtatStatusSollicitationRequestV2 | undefined,  cancelToken?: CancelToken): Promise<EtatSollicitation>;
}

export class SollicitationsClient extends AuthorizedApiBase implements ISollicitationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Génére un échange contenant la synthèse de la conversation a partir de l'idDocument du formulaire
     * @param body (optional) Objet contenant les données nécessaires à la synthèse d'une conversation
     * @return OK
     */
    syntheseConversationTLE(body?: SyntheseConversationTLEWithIdDocRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/sollicitations/synthese";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSyntheseConversationTLE(_response);
        });
    }

    protected processSyntheseConversationTLE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Met à jour le statut d'une téléexpertise vers MonSisra.Api.Abstractions.Transport.Enum.EtatSollicitation.EnCours
     * @param body (optional) 
     * @return No Content
     */
    startSollicitation(body?: StartSollicitationRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/sollicitations/start/sollicitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartSollicitation(_response);
        });
    }

    protected processStartSollicitation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Récupération des sollicitations (TLE ou demande d'appui) d'un ou plusieurs PS cible
     * @param body (optional) 
     * @return OK
     */
    getSollicitations(body?: GetSollicitationRequestV2 | undefined): Promise<GetConversationsResponse> {
        let url_ = this.baseUrl + "/api/v2/sollicitations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSollicitations(_response);
        });
    }

    protected processGetSollicitations(response: Response): Promise<GetConversationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetConversationsResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationsResponse>(null as any);
    }

    /**
     * Permet de modifier l'etat d'une sollicitation
     * @param idConversation Identifiant de la conversation
     * @param etat Nouvel etat de la sollicitation
     * @param body (optional) Données nécessaires pour changer le statut de la sollicitation
     * @return OK
     */
    setEtatSollicitation(idConversation: string, etat: EtatSollicitation, body?: SetEtatStatusSollicitationRequestV2 | undefined): Promise<EtatSollicitation> {
        let url_ = this.baseUrl + "/api/v2/sollicitations/conversation/{idConversation}/{etat}";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (etat === undefined || etat === null)
            throw new globalThis.Error("The parameter 'etat' must be defined.");
        url_ = url_.replace("{etat}", encodeURIComponent("" + etat));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetEtatSollicitation(_response);
        });
    }

    protected processSetEtatSollicitation(response: Response): Promise<EtatSollicitation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as EtatSollicitation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EtatSollicitation>(null as any);
    }
}

export interface ISsoClient {

    /**
     * Récupère tous les types de pièces jointes avec leur catégorie
     */
    startSession( cancelToken?: CancelToken): Promise<string>;
}

export class SsoClient extends AuthorizedApiBase implements ISsoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Récupère tous les types de pièces jointes avec leur catégorie
     */
    startSession(): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/sso/start/session";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartSession(_response);
        });
    }

    protected processStartSession(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : _responseText as string;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISynchroDocClient {

    /**
     * Télécharge le document courant et retourne les infos du document suivant
     * @return Contenu du document courant et infos du document suivant
     */
    getNextDoc(idCurrentDoc: number, format: EFormatDocEnum, conversationTypes: TypeConvSynchroDoc[],  cancelToken?: CancelToken): Promise<MetadataMultiDoc>;

    /**
     * Retourne l'id du next doc pour un PS et ses délégants, null s'il n'existe pas encore.
     * @return Id du next doc ou null
     */
    getIdNextDoc(idCurrentDoc: number, conversationTypes: TypeConvSynchroDoc[],  cancelToken?: CancelToken): Promise<number>;
}

export class SynchroDocClient extends AuthorizedApiBase implements ISynchroDocClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Télécharge le document courant et retourne les infos du document suivant
     * @return Contenu du document courant et infos du document suivant
     */
    getNextDoc(idCurrentDoc: number, format: EFormatDocEnum, conversationTypes: TypeConvSynchroDoc[]): Promise<MetadataMultiDoc> {
        let url_ = this.baseUrl + "/api/v2/synchrodoc/nextdoc/{idCurrentDoc}/{format}?";
        if (idCurrentDoc === undefined || idCurrentDoc === null)
            throw new globalThis.Error("The parameter 'idCurrentDoc' must be defined.");
        url_ = url_.replace("{idCurrentDoc}", encodeURIComponent("" + idCurrentDoc));
        if (format === undefined || format === null)
            throw new globalThis.Error("The parameter 'format' must be defined.");
        url_ = url_.replace("{format}", encodeURIComponent("" + format));
        if (conversationTypes === undefined || conversationTypes === null)
            throw new globalThis.Error("The parameter 'conversationTypes' must be defined and cannot be null.");
        else
            conversationTypes && conversationTypes.forEach(item => { url_ += "conversationTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNextDoc(_response);
        });
    }

    protected processGetNextDoc(response: Response): Promise<MetadataMultiDoc> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MetadataMultiDoc;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MetadataMultiDoc>(null as any);
    }

    /**
     * Retourne l'id du next doc pour un PS et ses délégants, null s'il n'existe pas encore.
     * @return Id du next doc ou null
     */
    getIdNextDoc(idCurrentDoc: number, conversationTypes: TypeConvSynchroDoc[]): Promise<number> {
        let url_ = this.baseUrl + "/api/v2/synchrodoc/id-next-doc/{idCurrentDoc}?";
        if (idCurrentDoc === undefined || idCurrentDoc === null)
            throw new globalThis.Error("The parameter 'idCurrentDoc' must be defined.");
        url_ = url_.replace("{idCurrentDoc}", encodeURIComponent("" + idCurrentDoc));
        if (conversationTypes === undefined || conversationTypes === null)
            throw new globalThis.Error("The parameter 'conversationTypes' must be defined and cannot be null.");
        else
            conversationTypes && conversationTypes.forEach(item => { url_ += "conversationTypes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdNextDoc(_response);
        });
    }

    protected processGetIdNextDoc(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IVisioClient {

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return OK
     */
    startVisio2(idConversation: string, source: ConversationSource, body?: StartVisioRequestV2 | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Closes a Visio session.
     * @param code The code associated with the session to be closed.
     * @return OK
     */
    closeVisio(code: string,  cancelToken?: CancelToken): Promise<void>;

    /**
     * Envoie un keepAlive
     * @param body (optional) Contient les données pour envoyer un KeepAlive
     * @return OK
     */
    keepAlive(body?: KeepAliveRequest | undefined,  cancelToken?: CancelToken): Promise<string>;

    /**
     * Renvoie les infos pour se connecter de manière sécurisée au serveur visio
     * @param roomName Nom de la salle de visio
     * @return OK
     */
    getInfosVisio(roomName: string,  cancelToken?: CancelToken): Promise<InfosVisioResult>;

    /**
     * Endpoint for checking the validity of a JWT token.
     * @param body (optional) Request containing the JWT token to be checked.
     * @return OK
     */
    checkJwtToken(body?: CheckJwtTokenRequest | undefined,  cancelToken?: CancelToken): Promise<JwtAuthenticationInfo>;
}

export class VisioClient extends AuthorizedApiBase implements IVisioClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Démarre une visioconférence
     * @param body (optional) Contient les données nécessaires pour démarrer la visio
     * @return OK
     */
    startVisio2(idConversation: string, source: ConversationSource, body?: StartVisioRequestV2 | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/visio/{source}/{idConversation}/start-visio";
        if (idConversation === undefined || idConversation === null)
            throw new globalThis.Error("The parameter 'idConversation' must be defined.");
        url_ = url_.replace("{idConversation}", encodeURIComponent("" + idConversation));
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartVisio2(_response);
        });
    }

    protected processStartVisio2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Closes a Visio session.
     * @param code The code associated with the session to be closed.
     * @return OK
     */
    closeVisio(code: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/visio/close?";
        if (code === undefined || code === null)
            throw new globalThis.Error("The parameter 'code' must be defined and cannot be null.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCloseVisio(_response);
        });
    }

    protected processCloseVisio(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Envoie un keepAlive
     * @param body (optional) Contient les données pour envoyer un KeepAlive
     * @return OK
     */
    keepAlive(body?: KeepAliveRequest | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v2/visio/KeepAlive";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processKeepAlive(_response);
        });
    }

    protected processKeepAlive(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : _responseText as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Renvoie les infos pour se connecter de manière sécurisée au serveur visio
     * @param roomName Nom de la salle de visio
     * @return OK
     */
    getInfosVisio(roomName: string): Promise<InfosVisioResult> {
        let url_ = this.baseUrl + "/api/v2/visio/GetInfosVisio?";
        if (roomName === undefined || roomName === null)
            throw new globalThis.Error("The parameter 'roomName' must be defined and cannot be null.");
        else
            url_ += "roomName=" + encodeURIComponent("" + roomName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfosVisio(_response);
        });
    }

    protected processGetInfosVisio(response: Response): Promise<InfosVisioResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InfosVisioResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InfosVisioResult>(null as any);
    }

    /**
     * Endpoint for checking the validity of a JWT token.
     * @param body (optional) Request containing the JWT token to be checked.
     * @return OK
     */
    checkJwtToken(body?: CheckJwtTokenRequest | undefined): Promise<JwtAuthenticationInfo> {
        let url_ = this.baseUrl + "/api/v2/visio/token/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckJwtToken(_response);
        });
    }

    protected processCheckJwtToken(response: Response): Promise<JwtAuthenticationInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as JwtAuthenticationInfo;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<JwtAuthenticationInfo>(null as any);
    }
}

export interface IVuesClient {

    /**
     * R�cup�re une liste de conversations en fonction des vues
     * @param body (optional) Contient la liste de vues, le page size et la potentielle recherche
     * @return OK
     */
    getConversationsByVues(body?: GetConversationByVuesRequest | undefined,  cancelToken?: CancelToken): Promise<GetConversationsResponse>;

    /**
     * Met à jour le menu d'un PS
     * @param body (optional) 
     * @return No Content
     */
    updateVuesStatus(body?: UpdateVuesStatusRequest | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class VuesClient extends AuthorizedApiBase implements IVuesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * R�cup�re une liste de conversations en fonction des vues
     * @param body (optional) Contient la liste de vues, le page size et la potentielle recherche
     * @return OK
     */
    getConversationsByVues(body?: GetConversationByVuesRequest | undefined): Promise<GetConversationsResponse> {
        let url_ = this.baseUrl + "/api/v2/vues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConversationsByVues(_response);
        });
    }

    protected processGetConversationsByVues(response: Response): Promise<GetConversationsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetConversationsResponse;
            return result200;
            });
        } else if (status === 206) {
            return response.text().then((_responseText) => {
            let result206: any = null;
            result206 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetConversationsResponse;
            return result206;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetConversationsResponse>(null as any);
    }

    /**
     * Met à jour le menu d'un PS
     * @param body (optional) 
     * @return No Content
     */
    updateVuesStatus(body?: UpdateVuesStatusRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v2/vues/status";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateVuesStatus(_response);
        });
    }

    protected processUpdateVuesStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IWorkflowClient {

    /**
     * Initialisation d'un document travail pour le PS connecté
     * @param type Liste des types de workflow
     * @return Identifiant du document travail qui vient d'être créé
     */
    initDocumentTravail(type: WorkflowType,  cancelToken?: CancelToken): Promise<InitDocumentTravailResponse>;

    /**
     * Initialisation d'un document travail pour le PS connecté
     * @param body (optional) 
     * @return Identifiant du document travail qui vient d'être créé
     */
    initSollicitationFormulaire(body?: InitSollicitationFormulaireRequest | undefined,  cancelToken?: CancelToken): Promise<InitSollicitationFormulaireResponse>;

    /**
     * Création d'une conversation
     * @param body (optional) 
     * @return Résultat de la création de la conversation
     */
    sendCreateConversation(body?: SendCreateConversationRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Création d'un courrier patient
     * @param body (optional) 
     * @return Résultat de la création du courrier patient
     */
    sendCreateMssPatient(body?: SendCreateMssPatientRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Création d'un courrier MSS
     * @param body (optional) 
     * @return Résultat de la création du courrier MSS
     */
    sendCreateMss(body?: SendCreateMssRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Création d'un courrier PS
     * @param body (optional) 
     * @return Résultat de la création du courrier PS
     */
    sendCreateCourrier(body?: SendCreateCourrierRequest | undefined): Promise<DocumentTravailSendResult>;

    /**
     * Envoi MSS et dépose dossier patient d'une synthèse de finalisation de TLE centrée patient
     * @param body (optional) 
     * @return Résultat de la création du courrier PS
     */
    sendSyntheseFinalisationTle(body?: SendSyntheseFinalisationTleRequest | undefined): Promise<DocumentTravailSendResult>;

    /**
     * Création d'une teleexpertise
     * @param body (optional) 
     * @return Résultat de la création de la sollicitation
     */
    sendCreateSollicitation(body?: SendCreateSollicitationRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Envoi d'un message dans une conversation
     * @param body (optional) 
     * @return Résultat de la création de la conversation
     */
    sendMessage(body?: SendMessageRequest | undefined,  cancelToken?: CancelToken): Promise<DocumentTravailSendResult>;

    /**
     * Récupère les éléments nécéssaires à la création d'un workflow à partir d'un id document travail
     * @return OK
     */
    getWorkflowFromDocumentTravail(idTechPsIdentifie: string, idDocumentTravail: string,  cancelToken?: CancelToken): Promise<WorkflowFromContext>;

    /**
     * Permet de récupérer un workflow dans le serveur de contexte à partir d'un idContext
     * @return OK
     */
    getWorkflowFromIdContext(idContext: string,  cancelToken?: CancelToken): Promise<WorkflowContext>;
}

export class WorkflowClient extends AuthorizedApiBase implements IWorkflowClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:5000/";
    }

    /**
     * Initialisation d'un document travail pour le PS connecté
     * @param type Liste des types de workflow
     * @return Identifiant du document travail qui vient d'être créé
     */
    initDocumentTravail(type: WorkflowType): Promise<InitDocumentTravailResponse> {
        let url_ = this.baseUrl + "/api/v2/workflows/init/{type}/document-travail";
        if (type === undefined || type === null)
            throw new globalThis.Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitDocumentTravail(_response);
        });
    }

    protected processInitDocumentTravail(response: Response): Promise<InitDocumentTravailResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitDocumentTravailResponse;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitDocumentTravailResponse>(null as any);
    }

    /**
     * Initialisation d'un document travail pour le PS connecté
     * @param body (optional) 
     * @return Identifiant du document travail qui vient d'être créé
     */
    initSollicitationFormulaire(body?: InitSollicitationFormulaireRequest | undefined): Promise<InitSollicitationFormulaireResponse> {
        let url_ = this.baseUrl + "/api/v2/workflows/init/sollicitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInitSollicitationFormulaire(_response);
        });
    }

    protected processInitSollicitationFormulaire(response: Response): Promise<InitSollicitationFormulaireResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitSollicitationFormulaireResponse;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitSollicitationFormulaireResponse>(null as any);
    }

    /**
     * Création d'une conversation
     * @param body (optional) 
     * @return Résultat de la création de la conversation
     */
    sendCreateConversation(body?: SendCreateConversationRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/conversation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCreateConversation(_response);
        });
    }

    protected processSendCreateConversation(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Création d'un courrier patient
     * @param body (optional) 
     * @return Résultat de la création du courrier patient
     */
    sendCreateMssPatient(body?: SendCreateMssPatientRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/mss-patient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCreateMssPatient(_response);
        });
    }

    protected processSendCreateMssPatient(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Création d'un courrier MSS
     * @param body (optional) 
     * @return Résultat de la création du courrier MSS
     */
    sendCreateMss(body?: SendCreateMssRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/mss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCreateMss(_response);
        });
    }

    protected processSendCreateMss(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Création d'un courrier PS
     * @param body (optional) 
     * @return Résultat de la création du courrier PS
     */
    sendCreateCourrier(body?: SendCreateCourrierRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/courrier";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCreateCourrier(_response);
        });
    }

    protected processSendCreateCourrier(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi MSS et dépose dossier patient d'une synthèse de finalisation de TLE centrée patient
     * @param body (optional) 
     * @return Résultat de la création du courrier PS
     */
    sendSyntheseFinalisationTle(body?: SendSyntheseFinalisationTleRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/send/synthese-tle-finalisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendSyntheseFinalisationTle(_response);
        });
    }

    protected processSendSyntheseFinalisationTle(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Création d'une teleexpertise
     * @param body (optional) 
     * @return Résultat de la création de la sollicitation
     */
    sendCreateSollicitation(body?: SendCreateSollicitationRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/sollicitation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendCreateSollicitation(_response);
        });
    }

    protected processSendCreateSollicitation(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Envoi d'un message dans une conversation
     * @param body (optional) 
     * @return Résultat de la création de la conversation
     */
    sendMessage(body?: SendMessageRequest | undefined): Promise<DocumentTravailSendResult> {
        let url_ = this.baseUrl + "/api/v2/workflows/create/message";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendMessage(_response);
        });
    }

    protected processSendMessage(response: Response): Promise<DocumentTravailSendResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DocumentTravailSendResult;
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentTravailSendResult>(null as any);
    }

    /**
     * Récupère les éléments nécéssaires à la création d'un workflow à partir d'un id document travail
     * @return OK
     */
    getWorkflowFromDocumentTravail(idTechPsIdentifie: string, idDocumentTravail: string): Promise<WorkflowFromContext> {
        let url_ = this.baseUrl + "/api/v2/workflows/convert/document-travail/{idDocumentTravail}?";
        if (idDocumentTravail === undefined || idDocumentTravail === null)
            throw new globalThis.Error("The parameter 'idDocumentTravail' must be defined.");
        url_ = url_.replace("{idDocumentTravail}", encodeURIComponent("" + idDocumentTravail));
        if (idTechPsIdentifie === undefined || idTechPsIdentifie === null)
            throw new globalThis.Error("The parameter 'idTechPsIdentifie' must be defined and cannot be null.");
        else
            url_ += "idTechPsIdentifie=" + encodeURIComponent("" + idTechPsIdentifie) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkflowFromDocumentTravail(_response);
        });
    }

    protected processGetWorkflowFromDocumentTravail(response: Response): Promise<WorkflowFromContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowFromContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowFromContext>(null as any);
    }

    /**
     * Permet de récupérer un workflow dans le serveur de contexte à partir d'un idContext
     * @return OK
     */
    getWorkflowFromIdContext(idContext: string): Promise<WorkflowContext> {
        let url_ = this.baseUrl + "/api/v2/workflows/convert/context/{idContext}";
        if (idContext === undefined || idContext === null)
            throw new globalThis.Error("The parameter 'idContext' must be defined.");
        url_ = url_.replace("{idContext}", encodeURIComponent("" + idContext));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWorkflowFromIdContext(_response);
        });
    }

    protected processGetWorkflowFromIdContext(response: Response): Promise<WorkflowContext> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkflowContext;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkflowContext>(null as any);
    }
}

/** Statut d'absence d'un délégant */
export interface Absence {
    /** Détermine si le PS est absent */
    isAbsent: boolean;
    /** Libellé de l'absence */
    libelle: string;
    /** Date de début de l'absence */
    dateDebut?: Date | undefined;
    /** Date de fin de l'absence */
    dateFin?: Date | undefined;
    /** Détermine si le PS veut recevoir des notifications pendant de son absence */
    notificationsOff: boolean;
}

export interface AbsencesConfig {
    available: boolean;
    endDateRequired: boolean;
    messageAbsenceRequired?: boolean | undefined;
    /** Affichage (ou non) de l'option "Désactiver les notifications" dans la pop-up d'absence */
    showDesactiverNotifs?: boolean | undefined;
}

export interface AddDestinatairesRequest {
    idDocumentTravail: string;
    destinataires: string[];
    commentaire: string;
    idTechPsIdentifie: string;
}

export interface AddMessageToConversationRequestV2 {
    /** Message de l'échange */
    message: string;
    /** Identifiant technique de l'auteur de l'échange */
    idTechPsAuteur: string;
}

export interface Adresse {
    idActivity: string;
    nomSite: string;
    voie: string;
    codePostal: string;
    codeInsee: string;
    ville: string;
    pays: string;
    isAdressePrincipale: boolean;
}

/** Adresse de naissance du patient */
export interface AdresseNaissanceStic {
    /** Code postal de naissance du patient */
    codePostal: string;
    /** Ville de naissance du patient */
    ville: string;
}

/** Adresse de residence du patient */
export interface AdresseResidenceStic {
    /** Adresse de residence du patient */
    adresse: string;
    /** Code postal de residence du patient */
    codePostal: string;
    /** Ville de residence du patient */
    ville: string;
}

export interface AuthConfig {
    /** Url de redirection pour le SSO avec le nom de domaine
domain/AutoConnectSSO/Redirect */
    autoConnectSsoRedirectBaseUrl: string;
    /** Type de mot de passe à utiliser */
    passwordType: PasswordType;
    /** Type de conversion certificat en refresh token */
    certificateConversionType: CertificateConversionType;
    /** Type d'identifiant du bureau */
    idPsType: IdPsType;
    /** Url de base de l'API protégée par certificat */
    certificateApiBase: string | undefined;
    /** Type du fournisseur d'identité */
    identityProviderType: IdentityProviderType;
    /** Si la définition de login/mdp depuis MSB est activée */
    accountCreationEnabled: boolean;
    /** Url de la page "mot de passe oublié" */
    forgotPasswordUrl?: string | undefined;
    /** Listes des domaines qui nécessitent l'utilisation d'un artefact ID (AURA) dans l'url */
    domainsWithAuthentication: string[];
}

/** Configuration liée à l'AutoConnectSSO */
export interface AutoConnectSSO {
    /** Url de base de l'AutoConnectSSO */
    baseUrl: string;
}

/** Configuration du module d'autosuggestion */
export interface AutoSuggestionModuleConfig {
    /** Indique si le module d'autosuggestion est activé */
    enabled: boolean;
    /** Regex de validation des adresses email MSS pour le Module d'autosuggestion */
    emailMSSValidationRegex?: string | undefined;
}

/** Configuration du bandeau d'infos */
export interface BandeauInfosConfig {
    /** Message d'infos */
    message: string;
    /** Bouton du bandeau d'infos */
    bouton?: BoutonBandeauInfos | undefined;
    /** Date de début d'affichage du bandeau */
    dateDebut: Date;
    /** Date de fin d'affichage du bandeau */
    dateFin?: Date | undefined;
    /** Couleur du message du bandeau */
    couleurTexte: string;
    /** Couleur de fond du bandeau */
    couleurFond: string;
}

export interface BaseFileWorkflow {
    /** Libellé du fichier avec l'extension */
    name: string;
    /** Type mime du fichier */
    contentType: string;
    /** Type de la pièce jointe (voir les nomenclatures) */
    idTypePiece?: number | undefined;
}

export interface Boite {
    /** Libéllé de la boite */
    label: string;
    /** Si la boite est séparée en deux (envoyés et reçus) */
    distinctSentReceived: boolean;
    /** Types de conversations ratachés à la boite */
    types: ConversationType[];
    /** Libelle de la boîte-icône existant dans le front qu'on souhaite utilisée */
    iconLabel?: string | undefined;
    /** Identifiant du parent */
    idParent?: TypeMenuBoite | undefined;
    /** Défini si la boite doit afficher le nombre de message non lus ou pas */
    hideNbNonLus?: boolean | undefined;
}

export interface BoiteItems {
    inbox: Boite;
    all: Boite;
    drafts?: Boite | undefined;
    results?: Boite | undefined;
    events?: Boite | undefined;
    unreads: Boite;
    conversations: Boite;
    courrier?: Boite | undefined;
    mss?: Boite | undefined;
    mssPatient?: Boite | undefined;
    /** BoiteSollicitation pour les TLE et demande d'appui */
    teleExpertise?: BoiteSollicitation | undefined;
    /** BoiteSollicitation pour les TLE et demande d'appui */
    demandeAppui?: BoiteSollicitation | undefined;
    dgs?: Boite | undefined;
    aTraiter: Boite;
    favoris: Boite;
    /** MSSanté */
    msSante?: Boite | undefined;
}

/** BoiteSollicitation pour les TLE et demande d'appui */
export interface BoiteSollicitation extends Boite {
    /** Si la boite est séparée en fonction de l'état (en cours ou clôturé) */
    distinctByState: boolean;
}

export interface BoitesConfig {
    items: BoiteItems;
    /** Si on peut ajouter ou supprimer la présence du patient dans la file active du PS */
    manageFileActive: boolean;
    /** Si on doit afficher le choix des boites de réception des délégants */
    showDelegantChoices: boolean;
    /** Le nombre de conversations/mails à afficher par page */
    pageSize: number;
    /** Affiche le bouton d'export TLE dans la boite TLE */
    boutonExportTLE: boolean;
    /** Liste les sections qui permettent d'ordonnançer les boites de réception */
    ordonnancementSectionsBoites: SectionConfig[];
}

/** Configuration d'un bouton du bandeau d'infos */
export interface BoutonBandeauInfos {
    /** Libellé du bouton */
    libelle: string;
    /** Lien du bouton */
    lien: string;
}

export interface ButtonPlusConfig {
    sections: Section[];
}

/** Type de conversion certificat en refresh token */
export enum CertificateConversionType {
    Internal = "Internal",
    Artefact = "Artefact",
}

/** Configuration liée aux Conditions générales d'utilisation */
export interface CguConfig {
    /** Lien de redirection vers les Conditions générales d'utilisation */
    link: string;
}

export interface CheckJwtTokenRequest {
    token: string;
}

/** Config du workflow de choix de type de conversation pour envoyer un fichier préalablement créé par l'imprimante */
export interface ChoixConversationConfig {
    /** Configuration des boutons de création de conversation */
    sections: Section[];
}

export enum Client {
    Aura = "aura",
    Paca = "paca",
    Occitanie = "occitanie",
    Pulsy = "pulsy",
    Idf = "idf",
    Hdf = "hdf",
}

export interface CommonConfig {
    /** Client (région) de l'application */
    client: Client;
    appName: string;
    /** Configuration liée à la visio */
    visio: VisioConfig;
    notification: NotificationConfig;
    /** Ouverture du dossier patient lors du clic sur son libéllé */
    openPatientFolder: boolean;
    /** Types de conversations gérés en tant que clavardage (Snacs.Messagerie) */
    conversationTypes: ConversationType[];
    /** Types de conversations gérés en tant que mail (Snacs.MSS / ApiSante) */
    mailTypes: ConversationType[];
    /** Configuration de la barre de SSO
Si null, on ne doit pas afficher la barre */
    autoConnectSsoBar?: AutoConnectSSO | undefined;
    /** Listes de fichiers JS à charger au lancement de l'application */
    javascriptFilesToLoad: string[];
    /** Status de connexion */
    statusConnexion: StatusConnexionConfig;
}

/** Configuration global lié à l'affihcga du mobile */
export interface CommonMobileConfig {
    /** Activation des fonctionnalités d'Odycare */
    odycareAvailable: boolean;
    tabs: TabConfig[];
    /** Permet la recherche de patient dans l'onglet Portail */
    searchPatientInPortailAvailable: boolean;
    /** Vérifie la validation des CGU au moment de la connexion */
    checkCGUValidation: boolean;
    /** Contenu du Menu mobile */
    globalMenu: GlobalMenuConfig;
    /** Récupère l'alert global pour l'afficher au démarrage de l'application */
    globalAlertAvailable: boolean;
    /** Indique si le clique sur le bouton de déconnexion inclue ou non la réinitialisation du compte */
    disconnectWithReinit: boolean;
}

export enum ContextFilter {
    ClavardageOnly = "ClavardageOnly",
    NotExpertsOnly = "NotExpertsOnly",
}

export interface ConversationDetail {
    idConversation: string;
    patient?: PatientConv | undefined;
    patientIppr?: string | undefined;
    sujet: string;
    listeEchanges: Echange[];
    listeEchangesCount: number;
    listeDestinataires: DestinataireReduit[];
    favorite: boolean;
    archivee: boolean;
    aTraiter: boolean;
    /** Délégant concerné */
    idTechPsDelegant: string;
    dateLecture?: Date | undefined;
    estLue: boolean;
    estPartagee: boolean;
    listeEvenements: Evenement[];
    montrerToutDestinataireOuNon?: boolean | undefined;
    /** Si le patient a le droit de répondre à la conversation (uniquement pour les conversations EchangePatient) */
    patientPeutRepondre?: boolean | undefined;
    /** l'adresse MSS du patient dans le cas d'un MSSPatient */
    adresseMSSPatient: string;
    type: ConversationType;
    areMembersInactive?: boolean | undefined;
    areMembersAbsent?: boolean | undefined;
    /** Données de la conversation de sollicitation - Utilisé pour les TeleExpertise et les DemandeAppui */
    donneesSollicitation?: Sollicitation | undefined;
    /** Id de l'échange qui correspond à la recherche faite par l'utilisateur */
    idEchangeSearched?: string | undefined;
    /** Index de la page dans laquelle l'échange recherché se trouve */
    pageIndexSearched?: number | undefined;
    mutee: boolean;
    source: ConversationSource;
    /** Si une visio existe et n'est pas clôturée pour cette conversation */
    isVisioStarted?: boolean | undefined;
}

export interface ConversationFiltre {
    estArchive?: boolean | undefined;
    estNonLu?: boolean | undefined;
    estATraiter?: boolean | undefined;
    estFavori?: boolean | undefined;
    estRecuOnly?: boolean | undefined;
    estEnvoyeOnly?: boolean | undefined;
    estATraiterOnly?: boolean | undefined;
    estClotureOnly?: boolean | undefined;
    recherche?: string | undefined;
    types: ConversationType[];
}

export interface ConversationLight {
    /** Cas conversation */
    idConversation: string;
    /** Cas brouillon */
    idBrouillon?: string | undefined;
    /** Nombre de destinataires si plusieurs.
Initiales du destinataire sinon */
    vignetteValeur: string;
    /** Couleur et opacité au format CSS rgba */
    vignetteCouleur: string;
    /** Premiere ligne de l'apercu des conversation */
    titre: string;
    /** Commentaire du dernier message de la conversation ou description PJ */
    sousTitre: string;
    /** Etat des indicateurs avec leur nom suivi de leur valeur :
ex: HasNoteImportante: null, HasImage: true */
    indicateursNonLu: Indicateurs;
    nombreNonLu: number;
    /** IPPR du patient concerné si applicable */
    patientIppr: string;
    /** ID du domaine du patient concerné si applicable */
    idPatientDomaine?: string | undefined;
    /** Prenom NOM du patient concerné si applicable */
    patientLibelle: string;
    /** Id du délégant à qui est adressée la conversation */
    idTechPsDelegant: string;
    /** Date du message le plus récent de la conversation */
    date: Date;
    estLue: boolean;
    aTraiter: boolean;
    archivee: boolean;
    favorite: boolean;
    /** Type de la conversation */
    type: ConversationType;
    dateLecture?: Date | undefined;
    isDestinataire: boolean;
    dernierMessage: string;
    dernierMessageId: string;
    dernierAuteur: ProfessionnelReduit;
    /** Statut de l'identité du patient */
    patientIdentityStatus: string;
    areMembersInactive?: boolean | undefined;
    areMembersAbsent?: boolean | undefined;
    /** Source de la conversation (Mss, MssSaraV2, Chat) */
    source: ConversationSource;
    /** Liste des documents uniquement pour les conversations MssSaraV2 */
    webmailDocs: WebmailMessageDocument[];
    mutee: boolean;
    destinataires: DestinataireReduit[];
    formulaires: FormulaireLight[];
}

export enum ConversationSource {
    Chat = "Chat",
    MSSSaraV2 = "MSSSaraV2",
    MSS = "MSS",
}

export enum ConversationType {
    BoiteReception = "BoiteReception",
    Brouillon = "Brouillon",
    NonLus = "nonLus",
    Tous = "tous",
    Conversation = "Conversation",
    Courrier = "Courrier",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Favoris = "favoris",
    ATraiter = "aTraiter",
    MSS = "MSS",
    EchangePatient = "EchangePatient",
    DGS = "DGS",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    AucunType = "AucunType",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

export interface ConversationsConfig {
    /** Configuration liée aux échanges */
    echanges: EchangesConfig;
    /** Configuration liée à la création d'un message */
    newMessage: NewMessageConfig;
    /** Configuration liée au formulaires (Odycare et Dominho) */
    form: FormConfig;
    /** Si on peut supprimer le status "Important" et "Question" d'une conversation */
    removeImportantQuestion: boolean;
    /** Si on doit afficher les conversations existantes lors de la création d'une conversation */
    showExistingConversations: boolean;
    isMuteAvailable: boolean;
    /** Ajoute le bouton "Créer un groupe à partir de cette conversation" dans le menu d'une conversation */
    createGroupFromConversation: boolean;
    /** Message de supression d'un message */
    deletedMessageLabel: string;
    /** Lien vers la création de groupe */
    creationGroupe: string;
    /** Config lié aux sollicitations */
    sollicitation: SollicitationConfig;
    /** Contient le message affiché si un utilisateur est inactif dans une conversation */
    labelUtilisateurConversationInactif?: string | undefined;
    /** Active les réactions à un échange avec les emojis */
    enableReactionsEmojis: boolean;
    /** Nombre de message a charger par l'infinite loader (0 = charger tous les messages) */
    infiniteScrollLoadNumber: number;
}

export interface CountByConversationStatus {
    tous: number;
    estArchive: number;
    estFavori: number;
    estATraiter: number;
}

/** Nombre total de mails non lus par status (sent, inbox, archive) */
export interface CountByMailStatus {
    /** Nombre de mails non lus envoyés */
    sent: number;
    /** Nombre de mails non lus reçus */
    inbox: number;
    /** Nombre de mails non lus archivés */
    archive: number;
}

/** Données en retour de la méthode M:MonSisra.Api.Abstractions.Interfaces.Services.IConversationService.CountConversationNonLusByTypeAndPs(MonSisra.Api.Abstractions.Transport.UserInfo,System.Collections.Generic.IReadOnlyCollection{System.String}) */
export interface CountConversationNonLusByTypeAndPsResponse {
    /** Données */
    data: { [key: string]: { [key: string]: CountByConversationStatus; }; };
    /** Dictionnaire remplie en cas d'erreur avec comme clé l'idTechPs et comme valeur le détail de System.Exception */
    errors: { [key: string]: string; };
}

export interface CountMailNonLusByTypeAndPsResponse {
    /** Liste des données par idTechPs */
    data: { [key: string]: CountByMailStatus; };
    /** Liste des erreurs par idTechPs */
    errors: ErrorDto[];
}

/** Cette classe définit les options pour la création de partages de conversation. */
export interface CreateConversationShareOptions {
    /** Obtient ou définit une valeur indiquant si la conversation est partagée avec le dossier du patient. */
    toPatientFolder: boolean;
}

/** Cette classe définit les options pour la création de partages de courrier. */
export interface CreateCourrierShareOptions {
    /** Obtient ou définit une valeur indiquant si le courrier est partagé avec le dossier du patient. */
    toPatientFolder: boolean;
    /** Obtient ou définit une valeur indiquant si le courrier est partagé avec le logiciel Ps. */
    toPsSoftware: boolean;
    /** Obtient ou définit une valeur indiquant si le courrier est envoyé à Msc. */
    sendToMsc: boolean;
}

/** Représentation d'une demande de création de fichier de travail à partir une pièce existante. */
export interface CreateExistingFichierTravailRequest {
    /** Identifiant du type pièce (optionnel). */
    idType?: number | undefined;
    /** Libelle du fichier */
    libelle: string;
    /** Source du document travail */
    destination?: ConversationSource | undefined;
    /** Identifiant du document travail */
    idDocumentTravail: string;
    /** Source du binaire */
    source: ConversationSource;
    /** Id local du document a conserver */
    idLocalDoc: string;
    /** Id de l'etablissement */
    idEts: number;
    /** IdTechPsIdentifié lié au fichier */
    idTechPsIdentifie: string;
}

export interface CreateFichierTravailRequestBase {
    /** Identifiant du document travail */
    idDocumentTravail: string;
    /** Source du document travail */
    source: ConversationSource;
    /** Id local du document a conserver */
    idLocalDoc?: string | undefined;
    /** Id de l'etablissement */
    idEts?: number | undefined;
}

export interface CreateFichierTravailFromContextRequest extends CreateFichierTravailRequestBase {
    /** Id du file context */
    idFileContext?: string;
}

export interface CreateNewFichierTravailRequest extends CreateFichierTravailRequestBase {
    idType?: number | undefined;
}

export enum CreateTypeEnum {
    Conversation = "Conversation",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
    Mss = "Mss",
    MssPatient = "MssPatient",
    Courrier = "Courrier",
}

/** Metadata pour la création d'un workflow context */
export interface CreateWorkflowContextMetadata {
    /** Type du workflow */
    type?: WorkflowType | undefined;
    /** Patient du workflow */
    patient?: PatientWorkflow | undefined;
    /** Liste des documents
Type du workflow */
    documents?: DocumentWorkflowContext[] | undefined;
    /** Objet du workflow */
    objet?: string | undefined;
    /** Message du workflow */
    message?: string | undefined;
}

/** Delegant lié a un ps MonSisra */
export interface DelegantMonSisra {
    /** Id du délégant */
    idTechPs: string;
    /** Id national du délégant */
    idNat: string;
    /** Libellé du delegant */
    libelle: string;
    /** EmailMss du delegant */
    emailMss?: string | undefined;
    /** Le délégant est une personne morale */
    estMorale: boolean;
    /** Statut du délégant */
    statut: StatutPsMonSisra;
    /** Droits du délégant */
    droits: DroitsPs;
}

/** Configuration liée à la suppression d'un échange Si = null alors la suppression est désactivée */
export interface DeleteConfig {
    timer?: number | undefined;
}

export interface DestinataireReduit {
    /** Libellé du PS : Prenom NOM */
    libelle: string;
    /** Nom du destinataire */
    nom: string;
    /** Prénom du destinataire */
    prenom: string;
    initiales: string;
    /** Identifiant technique du PS */
    idTechPs: string;
    /** Identifiant technique du PS */
    couleur: string;
    /** Identifiant technique du PS */
    email: string;
    /** Date de leture du dernier message */
    dateDerniereLecture?: Date | undefined;
    profession: Profession;
    specialite: Specialite;
    /** Définit si le destinataire est une personne morale ou non */
    estMorale: boolean;
    statut?: EStatutDestinataire | undefined;
    /** Message de statut du destinataire */
    messageStatut?: string | undefined;
}

/** Renvoi les echanges et les destinataires d'une conversation */
export interface DestinataireWorkflow {
    /** Id du Destinataire */
    idTechPs: string;
    /** Email du Destinataire */
    email: string;
    /** Nom du Destinataire */
    libelle: string;
}

export interface DisplayInMrps {
    /** Obsolete ? conversation existante qui après webif a été déplacé */
    conversations: boolean;
    /** Affichage de l'onglet des acteurs */
    acteursDossier: boolean;
    /** Affichage des experts et des équipe ressources */
    expertRessource: boolean;
    /** Pop-up de saisie de mail MSS dans le cas ou le PS n'en a pas */
    saisieEmail: boolean;
    /** Permet de sélectionner tous les ps (Obsolete ?) */
    selectAll: boolean;
    /** Affiche le bouton de géolocalisation */
    geolocalisation: boolean;
}

export interface DocumentTravailSendResult {
    /** Identifiant échangé créé */
    idEchange?: string | undefined;
    /** Identifiant conversation créé ou rapprochée */
    idConversation: string;
    idFormulaires: number[];
    succes: boolean;
    source: ConversationSource;
    typeConversation?: string | undefined;
}

/** Renvoi les éléments requis d'un document pour créer un workflow */
export interface DocumentWorkflow {
    /** Id du document */
    id: string;
    /** Nom du document */
    libelle: string;
    /** Type piece du document */
    type?: TypePieceWorkflow | undefined;
}

/** Représente un document */
export interface DocumentWorkflowContext extends BaseFileWorkflow {
    /** FileContextId du document */
    id: string;
}

export interface DocumentsConfig {
    shareToPatientFolder: ShareToPatientFolderConfig;
    onDocumentClick: OnDocumentClick;
    visioneuse: VisioneuseConfig;
    vignette: VignetteConfig;
    mimetypesAutorises: string[];
    /** Types de documents ouvrables sur la visionneuse interne MS */
    mimetypesToOpen: string[];
    erreurFormatDocument: string;
    documentTailleMaxEnMo: number;
    erreurTailleDocument: string;
    /** Les types pieces par defaut */
    typePiecesDefault: TypePiecesDefaultConfig;
    /** Type d'une PJ Synthese */
    typePieceSynthese: number[];
    /** Permettre l'ouverture du diapo photo */
    openDiapoPhoto: boolean;
}

/** Données permettant d'identifier un document */
export interface DocumentsId {
    /** Identifiant local du document */
    idLocalDoc: string;
    /** Identifiant de l'établissement */
    idEtablissement: number;
    /** Type de la conversation dans lequel se trouve le doc */
    type: ConversationType;
    /** Informations du PS identifié */
    infoPsDelegant: InfoPsIdentifie;
}

/** Droits d'un délégant */
export interface DroitsPs {
    /** Si on doit permettre au PS de centrer patient ses échanges ou d'intéragir avec le dossier du patient */
    accesAppCoordination: boolean;
    /** Si le PS a le droit d'accèder à la messagerie */
    estDelegueDiscussion: boolean;
    /** Si le PS a le droit d'accèder au dossier patient */
    estDelegueDossier: boolean;
}

export enum EFormatDocEnum {
    ORIGINAL = "ORIGINAL",
    PDF = "PDF",
    HTML = "HTML",
    IMAGES = "IMAGES",
    TEXT = "TEXT",
    VIGNETTE = "VIGNETTE",
}

export enum EHabilitationPS {
    Habilite = "Habilite",
    Intervenant = "Intervenant",
    Autre = "Autre",
}

export enum EImportanceDocument {
    Basse = "Basse",
    Normale = "Normale",
    Importante = "Importante",
    Vitale = "Vitale",
}

export enum ESex {
    F = "F",
    M = "M",
    I = "I",
}

export enum EStatutDestinataire {
    STATUT_USER_INACTIF = "STATUT_USER_INACTIF",
    STATUT_ABSENT = "STATUT_ABSENT",
    STATUT_EN_LIGNE = "STATUT_EN_LIGNE",
    STATUT_USER_ACTIF_MonSisra = "STATUT_USER_ACTIF_MonSisra",
    STATUT_USER_ACTIF_MSSante = "STATUT_USER_ACTIF_MSSante",
    STATUT_IGNORE = "STATUT_IGNORE",
}

export enum EStatutHabilitationDossier {
    Oui = "Oui",
    Non = "Non",
    Proscrit = "Proscrit",
    NonApplicable = "NonApplicable",
    OuiTemporaire = "OuiTemporaire",
}

/** Prise en compte de la doctrine V2 */
export enum EStatutHabilitationDossierV2 {
    HabiliteComplet = "HabiliteComplet",
    HabiliteLimite = "HabiliteLimite",
    HabiliteSynthese = "HabiliteSynthese",
    NonHabilitable = "NonHabilitable",
    Desactivee = "Desactivee",
    Proscrit = "Proscrit",
    NonHabilite = "NonHabilite",
}

export enum EStatutPieceDossier {
    IN = "IN",
    VA = "VA",
    TP = "TP",
}

export interface Echange {
    idEchange: string;
    /** Type de l'échange (Important / Question / Suivi / ...) */
    importance: string;
    dateHeure: Date;
    commentaire: string;
    commentaireHtml: string;
    auteur: DestinataireReduit;
    expediteur: DestinataireReduit;
    listeDocuments: WebmailMessageDocument[];
    premierNonLu: boolean;
    destinataireLu: DestinataireReduit[];
    formulaires: Formulaire[];
    /** Un échange peut contenir cette objet qui référence un autre échange auquel on répond */
    replyToEchange: ReplyToEchange;
    isDeleted: boolean;
    mentions: Mention[];
    /** Dictionnaire d'un idEmoji vers une liste l'idTechPS l'ayant utilisé */
    reactions: { [key: string]: string[]; };
}

/** Configuration liée aux échanges */
export interface EchangesConfig {
    /** Configuration liée à la suppression d'un échange
Si = null alors la suppression est désactivée */
    delete?: DeleteConfig | undefined;
    /** Si on peut répondre à un échange */
    answer: boolean;
}

/** Erreur lors de la récupération des données pour un PS */
export interface ErrorDto {
    /** Id technique du PS */
    idTechPs: string;
    /** Api qui a retourné l'erreur */
    source: ConversationSource;
    /** Détail de l'erreur */
    detail: string;
}

/** Regroupe les codes d'états courant d'une sollicitation */
export enum EtatSollicitation {
    Initialisee = "Initialisee",
    EnCours = "EnCours",
    Cloturee = "Cloturee",
}

export interface Evenement {
    /** Type de l'échange (Important / Question / Suivi / ...) */
    importance: string;
    dateHeure: Date;
    commentaire: string;
    idEvenement: string;
}

/** Enumération des sections qu'on peut déplier/replier */
export enum ExpandedSectionEnum {
    Clavardage = "Clavardage",
    Mss = "Mss",
    Vues = "Vues",
}

/** Contient les métadonnées et le contenu d'un fichier encodé en Base 64 */
export interface FileBase64Encoded {
    /** Contenu du fichier en base64
Attention il n'est pas logué */
    content?: string | undefined;
    /** MimeType du fichier */
    mimeType: string;
    /** Nom du fichier */
    fileName: string;
}

/** Données d'un fichier de prérequis d'une déclaration d'expert/d'équipe ressource */
export interface FichierPrerequisSollicitationWithContent extends FileBase64Encoded {
    /** URL de téléchargement du document */
    downloadUrl?: string | undefined;
    /** Identifiant du fichier */
    idFichier?: string | undefined;
    /** Libellé du fichier. Peut être différent du nom du fichier */
    libelle?: string;
}

/** Configuration d'affichage dans l'écran de file active (recherche patient) */
export interface FileActiveConfig {
    /** Affichage de l'onglet distance */
    displayDistance: boolean;
    /** Affichage du statut RNIV du patient */
    displayStatutRNIV: boolean;
    /** Permet la rediraction vers l'éran de création d'un patient (lié à Odycare) */
    creationPatientAvailable: boolean;
}

/** Fichier à ajouter au workflow */
export interface FileWorkflow extends BaseFileWorkflow {
    /** Données du fichier */
    data: string;
}

/** Décrit si on filtre sur un sous-ensemble de PS particuliers ou non */
export enum FilterOnly {
    Expert = "Expert",
    EquipeRessource = "EquipeRessource",
    ExpertEquipeRessource = "ExpertEquipeRessource",
    Mss = "Mss",
    AnnuaireSecuOnly = "AnnuaireSecuOnly",
    ClavardageOnly = "ClavardageOnly",
    NotExpertOnly = "NotExpertOnly",
}

/** Classe abstraite pour les filtres de vue. Il ne doit y avoir aucun attribut  dans cette classe */
export interface FiltreVue {
    $type: string;
}

/** Archivé, A traiter, Favori */
export interface FiltreVueClavardage extends FiltreVue {
    estATraiter?: boolean | undefined;
    estFavori?: boolean | undefined;
    estArchivee?: boolean | undefined;
}

/** Filtre Sent */
export interface FiltreVueMss extends FiltreVue {
    /** True = envoyé, false = reçu, null = pas de filtre */
    sent?: boolean | undefined;
    estArchivee?: boolean | undefined;
    /** Override pour vérifier si deux instances sont égales */
    estFavori?: boolean | undefined;
    estATraiter?: boolean | undefined;
}

/** Filtre Etat Sollicitation : Initialisee, EnCours, Cloturee */
export interface FiltreVueSollicitation extends FiltreVue {
    /** Etat de la sollicitation : Initialisee, EnCours, Cloturee */
    etatSollicitation: EtatSollicitation;
    estArchivee?: boolean | undefined;
}

/** Classe contenant les informations d'une vue épinglée d'un PS */
export interface FiltreVueVue {
    /** Id technique du PS pour lequel les vues sont affichées */
    idTechPs: string;
    /** Section correspondante de la vue (Clavardage|MSS) */
    section: SectionEnum;
    /** Types de conversation / mails concernés
            
Le BsonRepresentation est obligatoire car le driver ne sait pas sérialiser les liste d'énum à partir des Conventions */
    categories: ConversationType[];
    /** Filtres des types de messages (archivé, non lu, etc.) */
    filtres: FiltreVue;
}

/** Configuration liée au formulaires (Odycare et Dominho) */
export interface FormConfig {
    showButtonAccessOdycareForm: boolean;
    /** Défini si le mode chat actif des sollicitations est activé */
    enableChatDesactivation: boolean;
    /** Url formulaire patient */
    urlFormulaireAvecPatient?: string | undefined;
    /** Url formulaire sans patient */
    urlFormulaireSansPatient?: string | undefined;
    /** Defini le type de formulaire utilisé par l'environement */
    typeFormulaire: TypeFormulaire;
    /** Défini si la facturation est activé */
    isFacturationEnabled: boolean;
    /** Include the PDF report of a form in the conversation */
    includeRapportTeleExpertise: boolean;
}

export interface Formulaire {
    idInstanceFormulaire: string;
    libelleFormulaire: string;
    statutFormulaire: string;
}

export interface FormulaireLight {
    idInstanceFormulaire?: string | undefined;
    statutFormulaire: string;
}

/** Transport object of Form */
export interface FormulaireType {
    /** Technical identifier of form */
    formId: string;
    /** Label of form */
    formLabel: string;
    /** Type of form */
    type: string;
}

export interface FullConversation {
    detail: ConversationDetail;
    light: ConversationLight;
}

export interface FullMetadataDoc {
    auteur: MetadonneesDocumentUtilisateur;
    commentaire: string;
    dateActe?: Date | undefined;
    dateCreation: Date;
    destinataireAdeli: string;
    destinataireIdCarte: string;
    destinataireIdTechPs: string;
    destinataireNom: string;
    destinatairePrenom: string;
    destinataireRpps: string;
    etablissement: MetadonneesDocumentEtablissement;
    expediteur: MetadonneesDocumentUtilisateur;
    hash: string;
    idLocalDoc: string;
    idPieceTechnique?: number | undefined;
    idTypePiece: number;
    imagerieIds: ImagerieIds;
    importance: EImportanceDocument;
    invalidateur: InfoPS;
    invalidationCommentaire: string;
    invalidationDate?: Date | undefined;
    libelle: string;
    libelleTypePiece: string;
    libelleCourtTypePiece: string;
    patient: MetadataPatient;
    piecesLiees: PieceLiee[];
    statut: EStatutPieceDossier;
    typeConversation: ConversationType;
}

/** Objet de la requête GetConversationByVues */
export interface GetConversationByVuesRequest {
    /** Vues qui servent à identifier les conversations à remonter */
    vues: FiltreVueVue[];
    /** Nombre de conversation à récupérer */
    pageSize: number;
    /** Texte à rechercher */
    recherche?: string | undefined;
    /** Indique si on doit remonter les conversations non lues uniquement */
    estNonLu?: boolean | undefined;
}

export interface GetConversationDocumentRequest {
    idConversation: string;
    idTechPsDelegant: string;
    type: ConversationType;
    source: ConversationSource;
}

/** Erreur lors de la récupération des conversations */
export interface GetConversationsError {
    /** Message d'erreur */
    message: string;
    /** Message détaillé de l'erreur */
    details: string;
    /** Source de l'erreur */
    source: ConversationSource;
}

export interface GetConversationsRequestV2 {
    /** Nombre de conversation à récupérer */
    pageSize: number;
    filtre: ConversationFiltre;
    infoPsCibles: InfoPsIdentifie[];
}

export interface GetConversationsResponse {
    /** Données des conversations */
    data: ConversationLight[];
    /** Erreurs lors de la récupération des conversations */
    errors: GetConversationsError[];
}

/** Objet de requête afin de récupérer la listes des PS favoris du PS identifié */
export interface GetFavorisRequest {
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Filtre pour rechercher parmi une population de professionnel précise */
    filter: FilterOnly[];
}

/** Données nécessaires pour la méthode GetManyDocsWithSameFormat. */
export interface GetManyDocsWithSameFormatRequest {
    /** Format dans lequel les documents doivent être renvoyés */
    format: EFormatDocEnum;
    /** Données des documents à retourner au format voulu */
    documentsIds: DocumentsId[];
}

export interface GetPatientsParPS {
    suivis: PatientSuivi[];
    derniersConsultes: Patient[];
}

/** Objet de requête afin de récupérer la listes des PS récemment utilisé par le PS identifié */
export interface GetRecentsRequest {
    /** Identifiant technique de l'utilisateur identifié */
    idTechPsIdentifie: string;
    /** Filtre pour récupérer un nombre limité de profesionnel */
    quantite: number;
    /** Filtre pour rechercher parmi une population de professionnel précise */
    filter: FilterOnly[];
}

export interface GetSollicitationRequestV2 {
    /** Valeur de la pagination à récupérer */
    pagination: PaginationFiltre;
    etatSollicitation?: EtatSollicitation | undefined;
    /** Type de la Sollicitation à récupérer */
    typeSollicitation: TypeSollicitation;
    /** Liste des identifiants des PS cibles */
    infoPsCibles: InfoPsIdentifie[];
}

/** Contenu du Menu mobile */
export interface GlobalMenuConfig {
    /** Affiche le bouton pour accéder aux documents juridiques CGU, RGPD, Mentions Légales */
    displayDocumentsJuridiques: boolean;
    /** Affiche le bouton pour rediriger vers le profil du ps connecté dans le portail de config */
    displayMyProfil: boolean;
    /** Affiche le bouton pour rediriger vers le store afin de noter l'application */
    displayRate: boolean;
}

export interface Groupe {
    identifiant: string;
    nom: string;
    description: string;
    membresPP: PersonnePhysique[];
    membresPM: Service[];
}

export interface HabilitationDossier {
    dateDebutHabilitation?: Date | undefined;
    /** Date d'expiration du niveau d'habilitation. */
    dateFinHabilitation?: Date | undefined;
    /** Indique si l'habilitation donne également un droit de gestion des habilitations. */
    isGestionnaireHabilitations: boolean;
    /** Niveau d'habilitation accordé. */
    statutHabilitationDossier: EStatutHabilitationDossier;
}

/** Prise en compte de la doctrine V2 */
export interface HabilitationDossierV2 {
    dateDebutHabilitation?: Date | undefined;
    /** Date d'expiration du niveau d'habilitation. */
    dateFinHabilitation?: Date | undefined;
    /** Indique si l'habilitation donne également un droit de gestion des habilitations. */
    isGestionnaireHabilitations: boolean;
    /** Niveau d'habilitation accordé. */
    statutHabilitationDossierV2: EStatutHabilitationDossierV2;
}

/** Configuration spécifique au mobile */
export interface IConfigurationBureau {
    /** Configuration liée à l'authentification */
    auth: AuthConfig;
    /** Configuration liée à la LGC */
    lgc: LGCConfig;
    /** Links accessibles dans le menu roue crantée */
    links: Link[];
    /** Configuration de mise à jour automatique */
    update: UpdateConfig;
    /** Configuration liée à l'imprimante virtuelle (menu choix de conversation) */
    printer: PrinterConfig;
    /** Configuration liée aux Conditions générales d'utilisation */
    cgu?: CguConfig | undefined;
}

/** Configuration commune à tous les front (web, mobile, bureau) */
export interface IConfigurationFront {
    /** Configuration commune */
    common: CommonConfig;
    /** Configuration liée aux mails */
    mails: MailsConfig;
    /** Configuration liée aux patients */
    patient: PatientConfig;
    /** Configuration liée au module de recherche PS */
    moduleRecherchePS: ModuleRecherchePSConfig;
    /** Configuration liée au thème */
    theme: ThemeConfig;
    /** Configuration liée aux conversations */
    conversations: ConversationsConfig;
    /** Configuration liée aux boites */
    boites: BoitesConfig;
    /** Configurations liée aux documents */
    documents: DocumentsConfig;
    /** Configurations liée aux workflows */
    workflows: WorkflowsConfig;
    /** Configurations liée aux absences */
    absences: AbsencesConfig;
    /** Configurations liée au websocket */
    websocket: WebsocketConfig;
    /** Configuration liée au bandeau d'infos */
    bandeauInfos: BandeauInfosConfig;
}

/** Configuration spécifique au mobile */
export interface IConfigurationMobile {
    /** Configuration global lié à l'affihcga du mobile */
    common: CommonMobileConfig;
    /** Configuration d'affichage dans l'écran de file active (recherche patient) */
    fileActivePatient: FileActiveConfig;
    /** Configuration d'affichage dans le module de recherche du mobile */
    moduleRecherchePs: ModuleRechercheMobileConfig;
}

/** Type d'identifiant du bureau */
export enum IdPsType {
    IdTechPs = "IdTechPs",
    IdNational = "IdNational",
}

export enum IdentityProviderType {
    Keycloak = "Keycloak",
    IdentityServer = "IdentityServer",
}

export interface ImagerieIds {
    accessionNumber: string;
    idproducteur: string;
    studyUid: string;
}

export interface Indicateurs {
    important?: boolean | undefined;
    question?: boolean | undefined;
}

export interface InfoPS {
    adeli: string;
    idCarte: string;
    idTechnique: string;
    nom: string;
    prenom: string;
    rpps: string;
}

export interface InfoPsIdentifie {
    idTechPs: string;
    emailMSS?: string | undefined;
}

export interface InfosDoc {
    dateCreationEchange?: Date | undefined;
    idEchange: string;
    indexDocEchange: number;
    nbDocsRestant: number;
}

/** Objet de retour d'un appel à GetInfosVisio ATTENTION : les objets de retours DOIVENT rester en camelCase */
export interface InfosVisioResult {
    /** Jeton */
    jwtToken: string;
    /** Serveur */
    server: string;
    /** Temps en secondes entre chaque appel au keepAlive / SetDateFinTraceParticipant */
    keepAliveRate: number;
}

export interface InitDocumentTravailResponse {
    /** Identifiant du document travail */
    id: string;
    /** Source du document travail */
    source: ConversationSource;
}

/** Contient les données nécessaires pour qu'un PS puisse initialiser une sollicitation */
export interface InitSollicitationFormulaireRequest {
    /** Id de l'expert */
    idTechPsCible: string;
    /** Id de l'auteur */
    idTechPsAuteur: string;
    /** Ippr du patient */
    ippr?: string | undefined;
    /** Ins du patient */
    ins: string;
    /** Le type de sollicitation (Demande d'appui ou TLE) */
    typeSollicitation?: TypeSollicitation | undefined;
}

export interface InitSollicitationFormulaireResponse {
    idConversation: string;
    urlFormulaire: string;
}

/** Parmère liés à la fonctionnalité d'invitation d'un confrere */
export interface InvitationConfrereConfig {
    /** Activation de la fonctionnalité */
    invitationAvailable: boolean;
    /** Affichage du champ "Tèl. Mobile" dans l'écran d'invitation d'un confrere */
    viaSms: boolean;
    /** Un seul input pour le téléphone ou l'adresse */
    mergeEmailAndPhone: boolean;
}

export interface Item {
    label: string;
    tooltip: string;
    createType: CreateTypeEnum;
}

/** Response object after authenticating a JWT */
export interface JwtAuthenticationInfo {
    /** National identifier of a user */
    idNat: string;
    /** Email of a user */
    email: string;
}

/** Contient les données pour envoyer un KeepAlive */
export interface KeepAliveRequest {
    /** Nom de la visioconférence */
    roomName: string;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
}

/** Configuration de la synchro LGC (Logiciel de Gestion de Cabinet) - Ce qui permet de synchroniser automatiquement des documents sur la machine depuis MSB */
export interface LGCConfig {
    /** Si on doit ouvrir ou non la page de configuration lors de la première connexion */
    openConfigurationOnFirstConnection: boolean;
    /** Liste des types de documents que l'on souhaite synchroniser */
    typesDocs: TypesDoc[];
    /** Tags de nommage des documents que l'on souhaite synchroniser */
    tags: string[];
}

/** Contient les données nécessaires pour qu'un PS puisse quitter une conversation */
export interface LeaveConversationRequestV2 {
    /** Identifiant du PS qui quitte la conversation */
    idTechPsCible: string;
}

/** Configuration liée au Link */
export interface Link {
    /** Label du Link */
    label: string;
    /** Url du Link */
    url: string;
    /** Authentification required */
    requiresAuth: boolean;
}

/** Configuration liée aux mails */
export interface MailsConfig {
    /** Pop up Create MSS Account */
    popUpCreateMSSAccount: PopUpCreateMSSAccountConfig;
    /** Mimetype autorisé pour les courriers. Si vide, alors tous les mimetypes sont autorisés. */
    allowedMimeTypeCourrier?: string[] | undefined;
}

export interface Mention {
    /** Identifiant du PS mentionné */
    idTechPs: string;
    /** Nom du PS mentionné */
    nom: string;
}

/** Classe contenant les infos sur le PS par défaut sélectionné comme auteur */
export interface MenuDefaultWorkflow {
    /** Auteurs par défaut pour les sections Clavardage et MSS */
    authors: MenuDefaultWorkflowAuthors;
}

/** Classe contenant les PS par défaut sélectionné comme auteur pour la section Clavardage et MSS */
export interface MenuDefaultWorkflowAuthors {
    /** Auteur par défaut pour la section Clavardage */
    clavardage: string;
    /** Auteur par défaut pour la section Mss */
    mss: string;
}

/** Classe contenant les informations sur le pliage/dépliage des sections et sous boites */
export interface MenuIsExpanded {
    /** Sections dépliées */
    section: ExpandedSectionEnum[];
    /** Sous boites de clavardage dépliées pour un PS */
    clavardage: { [key: string]: TypeSousBoitesClavardage[]; };
    mss: { [key: string]: TypeSousBoitesMSS[]; };
    /** Sous boites de sollicitations dépliées pour un PS */
    sollicitation?: { [key: string]: SollicitationItem[]; } | undefined;
}

/** Classe contenant les informations du menu de messagerie */
export interface MenuMessagerie {
    /** Liste des vues épinglées */
    vuesEpinglees: FiltreVueVue[];
    /** Liste des id tech ps pour lesquels on affichera une boite de type "clavardages" */
    clavardageIdsTechPs: string[];
    /** Liste des id tech ps pour lesquels on affichera une boite MSS */
    mssIdsTechPs: string[];
    /** Informations sur l'expansion des menus (plié/déplié) */
    isExpanded: MenuIsExpanded;
    /** Gestion du PS par défaut sélectionné */
    defaultWorkflow: MenuDefaultWorkflow;
}

export enum MessageImportance {
    Normale = "Normale",
    Haute = "Haute",
    Question = "Question",
}

export interface SendBaseRequest {
    /** Identifiant technique de l'auteur */
    idTechPsAuteur: string;
    /** Idenfitiant technique du document de travail M:MonSisra.Api.Abstractions.Interfaces.Services.IWorkflowService.InitDocumentTravail(System.String,MonSisra.Api.Abstractions.Transport.V2.Enum.WorkflowType,System.Nullable{MonSisra.Api.Abstractions.Transport.Enum.MessagerieType}) à réutiliser */
    idDocumentTravail: string;
}

export interface MessageRequestBase extends SendBaseRequest {
    /** Contenu du message */
    message: string;
    /** Liste des mentions */
    mentions: Mention[];
    /** Importance du message */
    importance: MessageImportance;
}

/** Renvoi les echanges et les destinataires d'une conversation */
export interface MessagesDestinatairesConversation {
    /** Echanges d'une conversation */
    echanges: Echange[];
    /** Evenements d'une conversation */
    evenements: Evenement[];
    /** Destinataires d'une conversation */
    destinataires: DestinataireReduit[];
}

export interface MetadataMultiDoc {
    fullMetadataDoc: FullMetadataDoc;
    infosDoc: InfosDoc;
    multiDocs: MultiDoc[];
}

export interface MetadataPatient {
    codePaysNaissance: string;
    codePostalNaissance: string;
    dateNaissance?: Date | undefined;
    ippr: string;
    libellePaysNaissance: string;
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    sexe: ESex;
    villeNaissance: string;
}

export interface MetadonneesDocumentEtablissement {
    finess: string;
    idEtablissement: number;
    nom: string;
    nomCourt: string;
    oid: string;
}

export interface MetadonneesDocumentUtilisateur {
    /** Adeli */
    adeli: string;
    /** IdCarte */
    idCarte: string;
    /** IdProfession */
    idProfession: number;
    /** IdSpecialite */
    idSpecialite: number;
    /** IdTechnique */
    idTechnique: string;
    /** LibelleProfession */
    libelleProfession: string;
    /** LibelleSpecialite */
    libelleSpecialite: string;
    /** Mail */
    mail: string;
    /** Nom */
    nom: string;
    /** Prenom */
    prenom: string;
    /** RPPS */
    rpps: string;
}

export interface ModuleRechercheConfig {
    /** Indique si il est possible de sélectionner plusieurs PS */
    multiSelection: boolean;
    /** Indique ce qui doit etre aficher dans le MRPS */
    show: DisplayInMrps;
    /** Forcer le filtre qui est dans le MRPS (en haut à gauche) */
    defaultFilter: string;
    /** Utiliser côté MRPS pour connaitre le contexte, a changer pour prendre le niveau au dessus */
    nouveauCourrier: boolean;
    /** Force la recherche dans l'annuaire mss (duplicat modemss) */
    annuaireMss: boolean;
    /** Force la recherche dans l'annuaire sécu, utilisateur de nos appli */
    annuaireSecuOnly: boolean;
    /** Force la recherche dans l'annuaire mss */
    modeMss: boolean;
    /** Regroupe les filtres contextuels pour le MRPS */
    contextFilters: ContextFilter[];
    /** Context pour l'autosuggestion */
    utilisationContext: string;
    /** Forcer l'affichage du bouton + de sélection du ps */
    mustShowSelectButton: boolean;
}

/** Configuration d'affichage dans le module de recherche du mobile */
export interface ModuleRechercheMobileConfig {
    /** Parmère liés à la fonctionnalité d'invitation d'un confrere */
    invitationConfrere: InvitationConfrereConfig;
    /** Affiche la pop-up de détail du ps */
    displayPopupDetailPs: boolean;
    /** Affiche la section groupe dans le module de recherche */
    displayGroupe: boolean;
    /** Affiche une seule section dans le cas 'une téléexpertise ou d'une demande d'appui */
    displayOneSectionSollicitation: boolean;
}

/** Regroupe les données de filtre pour l'Annuaire OP dans le module de recherche */
export interface ModuleRechercheOPFilters {
    /** Filtres sur les professions de PS */
    professionPsFilters?: ProfessionOPFilter[] | undefined;
    /** Filtres sur les professions de UO */
    professionUoFilters?: ProfessionOPFilter[] | undefined;
    /** Filtres sur les modalités de prises en charge par défaut */
    defaultModalitesPecFilters?: PecEntityOPFilter[] | undefined;
}

export interface ModuleRecherchePSConfig {
    available: boolean;
    useAnnuaireMSSOnly: boolean;
    filtrerPPOnly: boolean;
    geolocation: boolean;
    ignoreEmail: boolean;
    autocompleteWho: boolean;
    isProfessionFieldAvailable: boolean;
    isSearchWithoutSelectionAvailable: boolean;
    showProfessionInSelectedPsList: boolean;
    showInvitationConfrere: boolean;
    showLessResult: boolean;
    hideFavorisMSS: boolean;
    hideRecentsMSS: boolean;
    labels: ModuleRecherchePSLabels;
    /** Configuration du module d'autosuggestion */
    autoSuggestionModule?: AutoSuggestionModuleConfig | undefined;
}

export interface ModuleRecherchePSLabels {
    labelSearchPlaceholderProfession: string;
    searchPlaceholderLocation: string;
    messagePopupInactif: string;
}

export interface ModuleRecherchePatientConfig {
    displayRecentPatients: boolean;
    showSearchInAnnuaireButton: boolean;
}

export interface MultiDoc {
    contenu: string;
    /** Libelle du document. 
Cas du service GetNextDoc pour MonSisra : construction d'un libellé spécifique pour être utilisé en nom de fichier. */
    libelle: string;
    idLocalDoc: string;
    idStic: number;
    mimeType: string;
    extension: string;
    format: EFormatDocEnum;
    /** Ordre de l'image car ce format génère 1 image / page. */
    numeroImage?: number | undefined;
    /** Nombre total d'images car ce format génère 1 image / page. */
    totalImages?: number | undefined;
}

/** Configuration liée à la création d'un message */
export interface NewMessageConfig {
    /** Si les options d'importances sont disponibles lors de la création d'un message */
    isImportancesAvailable: boolean;
    isMentionsAvailable: boolean;
}

export interface NotificationConfig {
    /** Titre de la fenetre de notification */
    intituleNotificationWindow: string;
}

export enum OnDocumentClick {
    Download = "Download",
    View = "View",
}

export interface PPAndServices {
    personnePhysiqueSuggestions: PersonnePhysique[];
    serviceSuggestions: Service[];
    groupeSuggestions: Groupe[];
}

export interface PaginationFiltre {
    /** Nombre de conversation à récupérer */
    count: number;
}

/** Type de mot de passe à utiliser */
export enum PasswordType {
    Password = "Password",
    Pin = "Pin",
}

export interface Patient {
    /** Gets or Sets patient ippr. */
    ippr: string;
    /** NomUsuel
Gets or Sets patient lastname. */
    lastName: string;
    /** Gets or Sets patient birthname. */
    birthName: string;
    /** Prenoms
Gets or Sets patient firstnames.
OBSOLETE Laissé pour rétro-compatibilité mobile, préférer FirstName
Attention, ne pas mettre la balise[Obsolete], sinon le champ n'est plus envoyé */
    listFirstNames: string[];
    /** Prenoms
Gets or Sets patient firstname. */
    firstName: string;
    /** Sewe
Gets or Sets patient sex. */
    sex: ESex;
    /** DateDeNaissance
Gets or Sets patient date of birth. */
    dateOfBirth: Date;
    /** CodePostalNaissance
Gets or Sets birth zip code. */
    birthZipCode: string;
    /** VilleNaissance
Gets or Sets birth city name. */
    birthCity: string;
    /** Gets or Sets birth country name. */
    birthCountry: string;
    /** Gets or Sets patient scoring field.
Pourcentage de similitude du doublon */
    scoringField: number;
    /** Gets or Sets a boolean value indicating if date of birth is sure. */
    isDateOfBirthSure: boolean;
    birthFirstName: string;
    identityStatus: string;
    /** Numéro de sécurité sociale du patient */
    nir?: string | undefined;
}

export interface PatientCarteVitale {
    /** Nom */
    lastName: string;
    /** Prénom */
    firstName: string;
    /** Nom de naissance = patronyme. */
    birthName: string;
    /** Date de naissance. */
    birthDate?: Date | undefined;
    /** IPPR récupéré à partir de STIC. */
    ippr: string;
}

export interface PatientConfig {
    /** Configuration du module de recherche patient */
    moduleRecherchePatient: ModuleRecherchePatientConfig;
    /** Url de création d'un dossier patient */
    urlCreateDossierPatient: string;
    /** Url d'acces a un dossier patient */
    urlOpenDossierPatient: string;
    urlCreatePatientMscAccount?: string | undefined;
    /** Nom de l'appli de gestion des patients */
    patientAppName: string;
    /** Gestion de l'affichage des infos détaillées du patient */
    displayExtendedInfosPatient: boolean;
}

export interface PatientConv {
    idPatient: string;
    /** ID du domaine du patient concerné si applicable */
    idPatientDomaine?: string | undefined;
    nomNaissance: string;
    nomUsuel: string;
    prenom: string;
    dateNaissance?: Date | undefined;
    sexe: ESex;
    codePaysNaissance: string;
    codeInseeNaissance: string;
    libellePaysNaissance: string;
    codePostalNaissance: string;
    villeNaissance: string;
    prenomNaissance: string;
    identityStatus: string;
    prenomsNaissanceList: string;
    isDeleted: boolean;
}

export interface PatientDetail extends Patient {
    phone?: string;
    mobilePhone?: string;
    email?: string;
    adresse?: string;
    city?: string;
    zipCode?: string;
    isDeleted?: boolean;
    listLocalData?: PatientLocal[];
}

export interface PatientHabilitation extends Patient {
    psHabiliteIntervenant?: EHabilitationPS;
}

/** Patient Stic Light */
export interface PatientLight {
    /** Prénom du patient */
    prenom: string;
    /** Nom d'usage du patient */
    nomUsage: string;
    /** Nom de naissance du patient */
    nomNaissance: string;
    /** Date de naissance du patient */
    dateNaissance?: Date | undefined;
    /** Sexe du patient */
    sexe: string;
    /** Email du patient */
    email: string;
    /** Numero de portable du patient */
    mobile: string;
    /** Adresse de naissance du patient */
    adresseNaissance: AdresseNaissanceStic;
    /** Adresse de residence du patient */
    adresseResidence: AdresseResidenceStic;
}

export interface PatientLocal {
    /** Gets or sets SI Name. */
    siName: string;
    /** Gets or sets patient usal name. */
    usualName: string;
    /** Gets or sets patient usal name. */
    phone: string;
    /** Gets or sets residence country. */
    country: string;
    /** Gets or sets address. */
    address: string;
    /** Gets or sets zip code. */
    zipCode: string;
    /** Gets or sets city. */
    city: string;
    /** Gets or sets email */
    email: string;
}

export interface PatientSuivi {
    /** IPPR du patient suivi */
    ippr: string;
    /** Nom de naissance du patient suivi */
    nomNaissance: string;
    /** Nom usuel du patient suivi */
    nomUsuel: string;
    /** Prénom du patient suivi */
    prenom: string;
    /** Sexe du patient suivi */
    codeSexe: string;
    /** Date de naissance du patient suivi */
    dateNaissance?: Date | undefined;
    /** Id de l'acteur professionnel qui suit le patient */
    idActeurPatient: number;
    /** Identifiant du statut de l'acteur */
    idStatutActeur: number;
    /** Date du dernier suivi, pour les acteurs ayant un statut spécifique qui indique qu'il suit le patient à intervalle régulier */
    dateDernierSuivi?: Date | undefined;
    /** Délai de récurrence du suivi, en jours, pour les acteurs ayant un statut spécifique qui indique qu'il suit le patient à intervalle régulier */
    delaiRecurrenceJour: number;
    /** Date de création du suivi de ce patient par l'acteur */
    dateCreation: Date;
    /** Habilitation de l'acteur professionnel sur le dossier du patient suivi */
    habilitationDossier: HabilitationDossier;
    /** Prise en compte de la doctrine V2 */
    habilitationDossierV2: HabilitationDossierV2;
    /** Commentaire patient récupéré */
    commentairePatient: string;
    /** Date de la dernière activité */
    dateDerniereActivite?: Date | undefined;
    /** Date du prochain rendez-vous */
    dateProchainRendezVous?: Date | undefined;
    /** Indique sue le patient possède une note importante */
    hasNoteImportante: boolean;
    /** Indique si une question concerne ce patient */
    hasQuestion: boolean;
    /** Indique si ce patient est sujet à un rappel de suivi */
    hasRappelDeSuivi: boolean;
    /** Indique si un document de ce patient a été marqué comme "à traiter"
par l'utilisateur en court */
    hasDocumentATraiter: boolean;
    /** Liste des IDs des étiquettes associées à ce patient */
    listeIdEtiquettes: number[];
    /** Indique si ce patient a un rappel de RDV */
    hasRappelDeRdv: boolean;
    /** Indique si ce patient est supprimer logiquement */
    supprime: boolean;
    prenomNaissance: string;
    identityStatus: string;
    lieuNaissance: string;
    /** Numéro de sécurité sociale du patient */
    nir?: string | undefined;
}

/** Patient du workflow */
export interface PatientWorkflow {
    /** Ippr du patient */
    ippr: string;
    /** Libelle du patient */
    libelle: string;
}

/** Données d'une entité liée aux prises en charge pour l'Annuaire OP */
export interface PecEntityOPFilter {
    /** Identifiant de l'entité liée aux prises en charge */
    id: number;
    /** Libellé de l'entité */
    libelle?: string | undefined;
    /** Code RA/générique de l'entité */
    code?: string | undefined;
}

export interface PersonnePhysique {
    idTechPS: string;
    idNatList: string[];
    idExercice: string;
    titre: string;
    nom: string;
    prenom: string;
    specialite: string;
    structure: string;
    villeCP: string;
    adressePostale: string;
    adresseMSS: string;
    email: string;
    telephoneFixe: string;
    telephoneMobile: string;
    telephoneSecretariat: string;
    teleExpert?: boolean | undefined;
    detailTeleExpertise: string;
    echangeBullePrerequisTeleExpertise: string;
    urlOutilTeleExpertise: string;
    centragePatientTeleExpertise: boolean;
    formulairesTeleExpertise: FormulaireType[];
    dematerialisation?: boolean | undefined;
    messageAbsence: string;
    msContactTeleExpertiseOnly?: boolean | undefined;
    isFavoris: boolean;
    statut: string;
    searchScore?: number | undefined;
    isAbsent?: boolean | undefined;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    activityAdresses: Adresse[];
}

export interface PieceJointeLight {
    nomDocument: string;
    typeMime: string;
}

export interface PieceLiee {
    dateCreation: Date;
    idEts: number;
    idLocalDoc: string;
    idPiece: number;
    libellePiece: string;
}

/** Configuration liée à la popup Medimail */
export interface PopUpCreateMSSAccountConfig {
    /** Texte d'indication à l'utilisateur */
    text: string;
    /** Link pour créer le compte ou service assistance */
    link: string;
}

export interface PreferencesExpert {
    /** Gets or sets IdTechPs */
    idTechPs: string;
    /** Gets or sets Description */
    description: string;
    /** Gets or sets UrlOutil */
    urlOutil: string;
    /** Gets or sets CentragePatient */
    centragePatient: boolean;
    /** Echange fictif à afficher dans la conversation pour présenter les */
    echangeBullePrerequis: string;
    formulaires: FormulaireType[];
}

/** Configuration liée à l'imprimante virtuelle */
export interface PrinterConfig {
    /** Configuration du menu de choix de conversation après avoir imprimé un fichier */
    choixConversation: ChoixConversationConfig;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface Profession {
    idProfession: number;
    nom: string;
    ordre?: number | undefined;
    estMorale: boolean;
}

/** Données liées aux filtres sur les professions pour l'Annuaire OP dans le module de recherche */
export interface ProfessionOPFilter {
    /** Identifiant de la profession */
    id: number;
    /** Nom de la profession */
    nom?: string | undefined;
    /** Spécialités liées à la profession */
    specialites?: SpecialiteAnnuaireOP[] | undefined;
    /** Prises en charge liées à la profession */
    pecs?: PecEntityOPFilter[] | undefined;
    /** Matériels de prise en charge liés à la profession */
    materielsPec?: PecEntityOPFilter[] | undefined;
    /** Modalités de prises en charge liées à la profession */
    modalitesPec?: PecEntityOPFilter[] | undefined;
    /** Décrit si la profession est considérée comme prioritaire ou non dans l'AR OP */
    isPrioritaire: boolean;
}

export interface ProfessionnelReduit {
    /** Libellé du PS : Civilite Prenom NOM - NomSpecialite */
    libelle: string;
    mail: string;
    /** Adresse MSS du professionnel */
    emailMSS: string;
    /** Libellé du PS : Civilite Prenom NOM - NomSpecialite */
    hasEmail: boolean;
    zeroPapier: boolean;
    /** Identifiant technique du PS */
    idTechPs: string;
    /** Identifiant de carte RPPS ou ADELI du PS */
    rppsOrIdCarteOrAdeli: string;
}

export interface ProfessionnelReduitWithSpecialite extends ProfessionnelReduit {
    specialite?: Specialite;
}

export interface ProfessionnelReduitDelegant extends ProfessionnelReduitWithSpecialite {
    estMorale?: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran "MesParcours" */
    habilitedMesParcoursMocas?: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran de création d'un parcours */
    habilitedCreationParcoursMocas?: boolean;
    /** Indique si le délégué de ce PS est gestionnaire de ces préférences */
    delegueEstGestionnairePreference?: boolean;
    /** Gets or sets the delegation state for discussion. */
    estDelegueDiscussion?: boolean;
    /** Gets or sets the delegation state for dossier. */
    estDelegueDossier?: boolean;
}

export interface ProfessionnelReduitDelegantWithStatus extends ProfessionnelReduitDelegant {
    statut?: Statut;
}

export interface ProfessionnelReduitSollicitation extends ProfessionnelReduitWithSpecialite {
    preferencesExpert?: PreferencesExpert;
    equipeRessource?: TEquipeRessource;
}

/** Utilisateur MonSisra */
export interface PsMonSisra {
    /** Id de l'utilisateur */
    idTechPsConnecte: string;
    /** L'utilisateur a validé les CGU */
    hasValidatedCGU: boolean;
    /** Liste des comptes auxquels le PS connecté a le droit d'agir en tant que (y compris lui même) */
    delegants: DelegantMonSisra[];
    /** Configuration du menu de l'utilisateur */
    menuMessagerie: MenuMessagerie;
    /** EmailMss du PS connecté */
    readonly emailMssConnecte?: string | undefined;
}

/** Un échange peut contenir cette objet qui référence un autre échange auquel on répond */
export interface ReplyToEchange {
    id: string;
    auteur: string;
    commentaire: string;
    date: Date;
    pieceJointes: PieceJointeLight[];
    isDeleted: boolean;
    mentions: Mention[];
}

export interface Section {
    description: string;
    type: TypeEnum;
    items: Item[];
}

/** Configuration d'une section d'ordonnancement des boites de réception */
export interface SectionConfig {
    /** Identifiants des boites de réception concernées par la section
Les boites sont ordonnées dans l'ordre d'affichage */
    boites: string[];
}

/** Enumération des sections de la messagerie (clavardage, mss) */
export enum SectionEnum {
    Clavardage = "Clavardage",
    Mss = "Mss",
}

export interface SendCreateConversationRequest extends MessageRequestBase {
    /** Sujet de la conversation */
    sujet: string;
    /** Liste des IdTechPS des destinataires */
    destinataires: string[];
    /** Identifiant technique du patient */
    ippr?: string | undefined;
    /** Cette classe définit les options pour la création de partages de conversation. */
    share: CreateConversationShareOptions;
}

export interface SendCreateCourrierRequest extends SendBaseRequest {
    /** Liste des destinataires */
    destinataires: string[];
    /** Liste des destinataires email MSS */
    destinatairesMSS?: string[] | undefined;
    /** Ippr du patient */
    patient: string;
    /** Cette classe définit les options pour la création de partages de courrier. */
    share: CreateCourrierShareOptions;
}

export interface SendCreateMssPatientRequest extends SendBaseRequest {
    /** Sujet de la conversation */
    sujet: string;
    /** Contenu du message */
    message: string;
    /** Id de l'auteur */
    ins: string;
}

export interface SendCreateMssRequest extends SendBaseRequest {
    /** Sujet de la conversation */
    sujet: string;
    /** Contenu du message */
    message: string;
    /** Liste des destinataires */
    destinataires: string[];
}

export interface SendCreateSollicitationRequest extends SendBaseRequest {
    /** IdTech de la personne sollicitée */
    idTechPsCible: string;
    /** INS du patient */
    nir?: string | undefined;
    /** Id du patient */
    patient?: string | undefined;
    /** Type de solicit */
    typeSollicitation: TypeSollicitation;
    /** Message a envoyer */
    message: string;
}

export interface SendMessageRequest extends MessageRequestBase {
    /** Identifiant technique de la conversation */
    idConversation: string;
    /** Identifiant technique de l'échange auquel on répond */
    replyToEchange?: string | undefined;
}

/** Contient les données nécessaires à l'envoi d'une synthèse de finalisation de TéléExpertise */
export interface SendSyntheseFinalisationTleRequest {
    /** Identifiant technique du professionnel agissant comme auteur. */
    idTechPsIdentifie: string;
    /** Identifiant de la conversation source de téléexpertise. */
    idConversation: string;
    /** Identifiant de l'établissement du document de synthèse. */
    idEtablissement: number;
    /** Identifiant de l'échange auquel est rattachée la synthèse de finalisation de TLE. */
    idEchange: string;
    /** Identifiant du type de pièce du document de synthèse. */
    idTypePiece: number;
}
export interface Service {
    id: string;
    idTechPS: string;
    idNat: string;
    nom: string;
    villeCP: string;
    adressePostale: string;
    adresseMSS: string;
    email: string;
    specialite: string;
    structure: string;
    equipeResource?: boolean | undefined;
    detailEquipeResource: string;
    echangeBullePrerequisEquipeResource: string;
    urlOutilEquipeResource: string;
    centragePatientEquipeResource: boolean;
    formulairesEquipeResource: FormulaireType[];
    teleExpert?: boolean | undefined;
    detailTeleExpertise: string;
    echangeBullePrerequisTeleExpertise: string;
    urlOutilTeleExpertise: string;
    centragePatientTeleExpertise: boolean;
    formulairesTeleExpertise: FormulaireType[];
    statut: string;
    isFavoris: boolean;
    searchScore?: number | undefined;
    isAbsent?: boolean | undefined;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    msContactTeleExpertiseOnly?: boolean | undefined;
}

/** Objet de transport de la requête SetAbsence */
export interface SetAbsenceRequest {
    /** Message d'absence */
    messageAbsence: string;
    /** Date de début de l'absence de l'utilisateur. */
    dateDebutAbsence?: Date | undefined;
    /** Date de fin de l'absence de l'utilisateur. */
    dateFinAbsence?: Date | undefined;
    /** Défini si l'utilisateur veut recevoir des notifications pour cette absence. */
    notificationOff?: boolean | undefined;
}

/** Requête pour définir les identifiants du compte SARA */
export interface SetAccountCredentialsRequest {
    /** Nouveau login portail du PS */
    login: string;
    /** Nouveau mot de passe du PS (en clair) */
    password: string;
}

/** Requête de mise à jour du statut d'une sollicitation */
export interface SetEtatStatusSollicitationRequestV2 {
    /** Identifiant technique du PS identifié */
    idTechPsIdentifie: string;
}

export interface ShareToPatientFolderConfig {
    /** Si le bouton au clic droit sur un document est disponible */
    showButton: boolean;
    /** Si la checkbox Partager sur ... dans l'écran de création de courrier est coché par défaut */
    defaultChecked: boolean;
}

/** Contient les données d'une sollicitation */
export interface Sollicitation {
    /** Identifiant de la conversation liée à la sollicitation */
    idConversation: string;
    /** Identifiant du formulaire utilisé */
    idFormulaire: string;
    /** Ippr du patient lié à la sollicitation */
    ippr: string;
    /** Identifiant technique du PS requérant */
    idTechPsRequerant: string;
    /** Identifiant technique du PS expert/équipe ressource */
    idTechPsReceveur: string;
    /** Identifiant technique de l'expert en charge */
    idTechPsExpertEnCharge?: string | undefined;
    /** Etat courant de la sollicitation */
    etatSollicitation: EtatSollicitation;
    /** Date du dernier échange de la conversation de sollicitation */
    dateDernierEchange: Date;
    /** Mode de préférence du chat : actif ou non */
    modeChatActif: boolean;
    /** Type de la sollicitation : Demande d'appui ou téléexpertise
Null dans le cadre de Snacs */
    typeSollicitation?: TypeSollicitation | undefined;
}

/** Configuration liée aux sollicitations */
export interface SollicitationConfig {
    /** L'url a contenant les infos sur la facturation */
    infosFacturation?: string | undefined;
    /** Le sujet de la sollicitation */
    sujetDemandeAppui: string;
    /** Couleur icône Sollicitation */
    distinctStateByColor: boolean;
    /** Nombre de caractères maximum de l'url outil */
    limiteOutilTelemedecineURL?: number | undefined;
}

/** Items pour sollicitations */
export interface SollicitationItem {
    /** Types de sous boites (actives, archivées, etc.) */
    filtre: TypeSousBoitesSollicitation;
    categorie: ConversationType;
}

/** extension de la classe Sollicitation afin d'avoir les information de facturation */
export interface SollicitationWithFactu extends Sollicitation {
    /** Numéro de facturation du requérent */
    numeroFacturationRequerant?: string | undefined;
    /** Numéro de facturation du receveur */
    numeroFacturationReceveur?: string | undefined;
}

export interface Specialite {
    /** Code technique de la spécialité. */
    codeSpecialite: number;
    /** Identifiant technique du groupe dont la spécialité fait partie. */
    idGroupeSpecialite?: number | undefined;
    /** Identifiant de la profession à laquelle la spécialité se rattache. */
    idProfession: number;
    /** Identifiant technique de la spécialité. */
    idSpecialite: number;
    /** Libellé de la spécialité */
    nom: string;
    /** Couleur hexadécimale attribuée à la spécialité. */
    couleur: string;
    /** Ordre d'affichage de la spécialité. */
    ordre: number;
    /** Acteur premier recours */
    estPremierRecours: boolean;
}

/** Données de spécialité pour l'Annuaire OP */
export interface SpecialiteAnnuaireOP {
    /** Identifiant de la spécialité */
    id: number;
    /** Nom de la spécialité */
    nom?: string | undefined;
    /** Prises en charge liées à la spécialité */
    pecs?: PecEntityOPFilter[] | undefined;
    /** Matériels de prise en charge liés à la spécialité */
    materielsPec?: PecEntityOPFilter[] | undefined;
    /** Modalités de prises en charge liées à la spécialité */
    modalitesPec?: PecEntityOPFilter[] | undefined;
}

/** Requête qui passe une sollicitation à l'état MonSisra.Api.Abstractions.Transport.Enum.EtatSollicitation.EnCours */
export interface StartSollicitationRequest {
    /** IdTechPs du délégant de la conversation */
    idTechPsDelegant: string;
    /** Identifiant de la conversation */
    idConversation: string;
}

/** Contient les données nécessaires au démarrage d'une visio */
export interface StartVisioRequestV2 {
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    infoPsIdentifie: InfoPsIdentifie;
}

export interface StatusConnexion {
    status: StatusConnexionEnum;
    libelle: string;
}

export interface StatusConnexionConfig {
    status: StatusConnexion[];
}

export enum StatusConnexionEnum {
    STATUT_USER_INACTIF = "STATUT_USER_INACTIF",
    STATUT_ABSENT = "STATUT_ABSENT",
    STATUT_EN_LIGNE = "STATUT_EN_LIGNE",
    STATUT_USER_ACTIF_MonSisra = "STATUT_USER_ACTIF_MonSisra",
    STATUT_USER_ACTIF_MSSante = "STATUT_USER_ACTIF_MSSante",
    STATUT_IGNORE = "STATUT_IGNORE",
}

export interface Statut {
    idTechPS: string;
    derniereConsultationMessagerie?: Date | undefined;
    dernierMailMss?: Date | undefined;
    isAbsent: boolean;
    libelleAbsence: string;
    dateDebutAbsence?: Date | undefined;
    dateFinAbsence?: Date | undefined;
    /** Pour les personnes qui ne peuvent pas avoir de statut (ex: equipe ressources regions snacs) */
    isIgnore?: boolean | undefined;
    /** Détermine si le PS veut recevoir des notifications pendant de son absence */
    notificationsOff: boolean;
}

/** Statut d'un délégant */
export interface StatutPsMonSisra {
    /** Date de dernière consultation */
    dateDerniereConsultation?: Date | undefined;
    /** Statut d'absence d'un délégant */
    absence?: Absence | undefined;
}

/** Contient les données nécessaires à la synthèse d'une conversation */
export interface SyntheseConversationRequest {
    /** Identifiant de la conversation à mettre à jour */
    idConversation: string;
    /** Liste des id des échanges à inclure dans la synthèse */
    echangesIds: any;
    /** Identifiant du PS déléguant pour lequel l'utilisateur travaille */
    idTechPsIdentifie: string;
    /** Optionnel : indique si la synthèse TLE est finalisée */
    isFinalisationTle?: boolean | undefined;
}

/** Contient les données nécessaires à la synthèse d'une conversation avec un fichier */
export interface SyntheseConversationTLERequest extends SyntheseConversationRequest {
    /** Fichier du formulaire */
    fichierFormulaireFinalisation?: FileBase64Encoded | undefined;
}

/** Contient les données nécessaires à la synthèse d'une conversation avec un IdFormulaire */
export interface SyntheseConversationTLEWithIdDocRequest extends SyntheseConversationRequest {
    /** Id d'un formulaire de sollicitation */
    idFormulaire?: string | undefined;
}

export interface TEquipeRessource {
    /** Identifiant technique de l'utilisateur */
    idTechPs: string;
    /** Description de l'activité de l'équipe ressoure */
    description: string;
    /** Url de l'outil utilisée pour demander l'avis de l'équipe ressoure */
    urlOutil: string;
    /** Centrer ou non une nouvelle de sollicitation autour d'un patient . */
    centragePatient: boolean;
    /** Echange fictif à afficher dans la conversation pour présenter les */
    echangeBullePrerequis: string;
    formulaires: FormulaireType[];
}

/** Propriétés d'une tab affiché en bas de l'application mobile */
export interface TabConfig {
    /** Nom affiché sur la tab */
    name: string;
    /** Chemin de redirection de la tab au clique dessus */
    route: string;
}

/** Options spécifiques aux téléexpertises */
export interface TeleExpertiseOptions {
    /** Regex pour vérifier le numéro de facturation renseigné par l'utilisateur lors : 
- la création / finalisation d'une téléexpertise 
- la modification de ses préférences de sollicitation */
    numFacturationRegex?: string | undefined;
}

export interface ThemeConfig {
    backgroundColor: string;
    /** Couleur spécifique pour les boutons */
    mssTextColor: string | undefined;
}

export interface TokenAttributes {
    authenticationMode: string;
    ssoUserLastName: string;
    ssoUserFirstName: string;
    ssoAuthenticationLevel: number;
    ssoUserTechId: string;
    subjectNameId: string;
}

/** Type passé de msb (depuis  la 1.12) à MonSisra.API (puis vers Snacs.SynchroDoc) */
export enum TypeConvSynchroDoc {
    Aucune = "Aucune",
    Conversation = "Conversation",
    Resultat = "Resultat",
    RendezVous = "RendezVous",
    Courrier = "Courrier",
    MSS = "MSS",
    DGS = "DGS",
    EchangePatient = "EchangePatient",
    MSSPatient = "MSSPatient",
    CourrierPatient = "CourrierPatient",
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

export enum TypeEnum {
    Mss = "Mss",
    MssPatient = "MssPatient",
    Messagerie = "Messagerie",
}

/** Contient les differents type de formulaires gérés par l'API */
export enum TypeFormulaire {
    Dominho = "Dominho",
    Odycare = "Odycare",
}

export enum TypeMenuBoite {
    BoiteReception = "BoiteReception",
    Conversation = "Conversation",
    Courrier = "Courrier",
    CourrierPatient = "CourrierPatient",
    DGS = "DGS",
    DemandeAppui = "DemandeAppui",
    EchangePatient = "EchangePatient",
    Evenement = "Evenement",
    MSS = "MSS",
    MSSPatient = "MSSPatient",
    NombreNonLu = "NombreNonLu",
    RendezVous = "RendezVous",
    Resultat = "Resultat",
    TeleExpertise = "TeleExpertise",
    ATraiter = "ATraiter",
    Favoris = "Favoris",
    NonLus = "NonLus",
    Tous = "Tous",
    MSSante = "MSSante",
}

export interface TypePieceWithCategorie {
    /** Gets or sets id of the type of piece. */
    id: number;
    /** Gets or sets the category. */
    categorie: string;
    /** Gets or sets name of the type of piece */
    nom: string;
}

/** Type piece du document d'un workflow */
export interface TypePieceWorkflow {
    /** Id du type piece */
    id: number;
    /** Nom du type piece */
    libelle: string;
}

/** Les types pieces par defaut */
export interface TypePiecesDefaultConfig {
    /** IdTypiece pour les PJ de conversation */
    idTypePieceAutreDocument: number;
    /** IdTypePiece pour les images de conversation */
    idTypePieceImage: number;
    /** Ancien IdTypePiece pour les AutreDocuments */
    idTypePieceOldAutreDocument: number;
    /** Ancien IdTypePiece pour les Images */
    idTypePieceOldImage: number;
}

/** Regroupe les types de sollicitation */
export enum TypeSollicitation {
    TeleExpertise = "TeleExpertise",
    DemandeAppui = "DemandeAppui",
}

/** Types de sous boites (actives, archivées, etc.) */
export enum TypeSousBoitesClavardage {
    Actives = "Actives",
    Archives = "Archives",
    Etiquettes = "Etiquettes",
}

/** Types de sous boites (actives, archivées, etc.) */
export enum TypeSousBoitesMSS {
    BoiteReception = "BoiteReception",
    Envoyes = "Envoyes",
    Archives = "Archives",
    Etiquettes = "Etiquettes",
}

/** Types de sous boites (actives, archivées, etc.) */
export enum TypeSousBoitesSollicitation {
    Actives = "Actives",
    Archives = "Archives",
}

/** Informations des types de documents à télécharger pour la synchro LGC */
export interface TypesDoc {
    /** Libellé du type */
    libelleType: string;
    /** Libellé d'aide du type (infos supplémentaires) */
    libelleAideType: string;
    /** Types de conv */
    types: TypeConvSynchroDoc[];
}

/** Configuration de mise à jour automatique */
export interface UpdateConfig {
    /** Mapping des versions de l'application (version interne => version publique) */
    mapping: { [key: string]: string; };
    webEtagUrls: string[];
}

/** Contient les données permettant de mettre à jour les conversations d'un utilisateur */
export interface UpdateConversationsStatusRequestV2 {
    /** Indique si les conversations sont à archiver ou non */
    action: UpdateConversationsUtilisateurAction;
    /** Filtre sur les conversations à modifier */
    filtre: ConversationFiltre;
    infoPsCibles: InfoPsIdentifie[];
}

export enum UpdateConversationsUtilisateurAction {
    MettreALu = "MettreALu",
    Archiver = "Archiver",
}

/** Modifier d'un échange */
export enum UpdateEmojiModifier {
    Add = "Add",
    Remove = "Remove",
}

/** Modifie le status de favori d'un widget */
export enum UpdateFavoriWidgetModifier {
    Add = "Add",
    Remove = "Remove",
}

export interface UpdateFileActiveStatusRequestV2 {
    ippr: string;
    /** Si le patient est dans la file active du PS */
    isInFileActive: boolean;
}

/** Contient l'IdTechPSDelegant du PS qui réagit à un échange et l'Unicode de l'emoji en question */
export interface UpdateReactionRequest {
    /** IdPsDelegant du Ps qui ajoute une réaction */
    idTechPsDelegant: string;
    /** Unicode de l'emoji en question */
    idEmoji: string;
}

export interface UpdateStatutConversationRequestV2 {
    infoPsIdentifie: InfoPsIdentifie;
    estLue?: boolean | undefined;
    archivee?: boolean | undefined;
    estFavorie?: boolean | undefined;
    estMutee?: boolean | undefined;
    aTraiter?: boolean | undefined;
    type: string;
    estImportant?: boolean | undefined;
    estQuestion?: boolean | undefined;
    idTechPsCible: string;
}

/** Objet de la requête UpdateVuesStatus */
export interface UpdateVuesStatusRequest {
    /** Indique si les conversations sont à archiver ou à mettre à lus */
    action: UpdateConversationsUtilisateurAction;
    /** Filtre sur les élements à modifier */
    vues: FiltreVueVue[];
}

export interface UserInfo {
    /** Private property for Libelle */
    libelle: string;
    /** Civilité du PS (M. Mme. Dr. ...) */
    civilite: string;
    /** Prénom du PS */
    prenom: string;
    /** Nom du PS */
    nomUsuel: string;
    mail: string;
    emailMSS: string;
    /** Private property for IdCarte */
    idCarte: string;
    /** Private property for IdTechPSConnecte */
    idTechPSConnecte: string;
    /** Liste des délégants de l'utilisateur connecté */
    listeDelegants: ProfessionnelReduitDelegant[];
    /** Stocke toutes les informations du jeton. */
    tokenAttributes: TokenAttributes;
    /** Stocke les informations du patient s'il a été connecté par Carte Vitale. */
    patientCarteVitale: PatientCarteVitale;
    /** Info qui permet de savoir si le PS connecté à droit de se connecter en Bris de Glace */
    isBrisDeGlaceAuthorized: boolean;
    /** L'utilisateur connecté est administrateur : accès autorisé à toutes les interfaces d'administration et d'appeller les services d'admin */
    isAdmin: boolean;
    /** L'utilisateur connecté est gestionnaire d'équipe : accès autorisé aux interfaces d'administration des équipes/établissements + webs services d'admin des équipes */
    isAdminTeams: boolean;
    /** L'utilisateur connecté est hotliner : accès autorisé à la page d'administration : gestion des comptes uniquement */
    isHotliner: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran "MesParcours" */
    habilitedMesParcoursMocas: boolean;
    /** Indique si l'utilisateur est habilité à acceder a l'écran de création d'un parcours */
    habilitedCreationParcoursMocas: boolean;
    /** Indique si l'utilisateur a déjà validé les CGUs. */
    hasValidatedCGU?: boolean | undefined;
    /** Date de dernière activité, null si jamais connecté */
    dateDerniereActivite?: Date | undefined;
}

export interface UserInfoV2 extends UserInfo {
    listeDelegants: ProfessionnelReduitDelegantWithStatus[];
    statut?: Statut;
}

/** Informations de nom, prénom, libellés de profession et spécialité d'un professionnel */
export interface UserProfessionSpecialite {
    /** Prenom du PS */
    prenom: string;
    /** Nom du PS */
    nom: string;
    /** Libelle de la profession du PS */
    profession: string;
    /** Libelle de la specialite du PS */
    specialite: string;
}

export interface VignetteConfig {
    available: boolean;
    /** Si l'affichage des vignettes se base sur le type MIME et non pas le type de document (Image/Autre)
TODO à voir si c'est a maintenir vu que AURA l'utilise aussi */
    basedOnMimeType: boolean;
}

/** Configuration liée à la visio */
export interface VisioConfig {
    /** Si la fonctionnalité de visio est disponible */
    available: boolean;
    /** Délai en millisecondes avant de refaire sonner une même visio */
    sonnerieTimeout: number;
    /** Url pour rejoindre la visio */
    visioUrl: string;
    /** Type de visio utilisée
Exemple : pandalab ou jitsi */
    type: VisioType;
}

/** Enumeration representing different types of Visio platforms. */
export enum VisioType {
    Jitsi = "jitsi",
    Pandalab = "pandalab",
}

export interface VisioneuseConfig {
    setPsIdentifieInLienDoc: boolean;
}

export interface WebmailMessageDocument {
    lienDocument: string;
    nomDocument: string;
    libelleTypePiece: string;
    /** Identifiant local du document s'il provient d'un échange Zepra */
    idLocalDoc: string;
    etablissementId: number;
    idPiece?: string | undefined;
    date: Date;
    idTypePiece?: number | undefined;
    typeMime: string;
}

/** Configuration du websocket */
export interface WebsocketConfig {
    /** Timeout de vérification du websocket en ms */
    pingIsAliveDelay: number;
}

export interface Widget {
    authenticationLevel: number;
    id: number;
    isFavori: boolean;
    liens: WidgetLink[];
    mainUrl: string;
    nom: string;
    urlLogo: string;
}

export interface WidgetLink {
    isSsoLink: boolean;
    nom: string;
    originalApplicationUrl: string;
    url: string;
}

export interface WidgetList {
    widgets: Widget[];
}

export interface WorkflowContext extends CreateWorkflowContextMetadata {
    id: string;
}

/** Represente la configuration pour le workflow de partage de conversation */
export interface WorkflowConversationShareOptions {
    /** Si la checkbox Partager ces informations dans le dossier du patient est disponible */
    isPartageDossierPatient: boolean;
}

/** Représente la configuration pour le workflow de partage de courrier sur la checkbox "Envoyer une copie dans mon logiciel métier". */
export interface WorkflowCourrierShareLogicielMetier {
    /** Si la checkbox dans l'écran de création de conversation / courrier est disponible */
    showCheckbox: boolean;
    /** États par défaut de la checkbox dans l'écran de création de conversation / courrier */
    defaultStates: DefaultStates;
}

/** Represente la configuration pour le workflow de partage de courrier sur la checkbox "Partager sur Ma Sante Connectee". */
export interface WorkflowCourrierShareOptions {
    /** Si la checkbox Partager sur Ma Santé Connectée dans l'écran de création de courrier est disponible */
    isMaSanteConnectee: boolean;
    /** Si la checkbox Envoyer une copie dans mon logiciel métier dans l'écran de création de courrier est disponible + Etat de la checkbox */
    logicielMetier?: WorkflowCourrierShareLogicielMetier | undefined;
}

/** Renvoi les éléments nécessaire a la création d'un workflow */
export interface WorkflowFromContext {
    /** Message du workflow */
    message: string;
    /** Objet du workflow */
    objet: string;
    /** Liste des documents du workflow */
    documents: DocumentWorkflow[];
    /** Destinataires du workflow */
    destinataires: DestinataireWorkflow[];
    /** Type du workflow */
    type: WorkflowType;
}

/** Liste des types de workflow */
export enum WorkflowType {
    CreateCourrierPs = "CreateCourrierPs",
    CreateCourrierPatient = "CreateCourrierPatient",
    CreateMss = "CreateMss",
    CreateConversation = "CreateConversation",
    CreateDemandeAppui = "CreateDemandeAppui",
    CreateTeleExpertise = "CreateTeleExpertise",
    EditConversation = "EditConversation",
    EditDemandeAppui = "EditDemandeAppui",
    EditTeleExpertise = "EditTeleExpertise",
}

export interface WorkflowsConfig {
    /** Si true, les courriers sont rangés dans la section MSS */
    manageCourrierAsMss: boolean;
    /** Configuration du bouton plus */
    buttonPlus: ButtonPlusConfig;
    /** Options de partage du courrier */
    courrierShareOptions: WorkflowCourrierShareOptions;
    /** Options de partage de conversation */
    conversationShareOptions: WorkflowConversationShareOptions;
    /** Défini le workflow a lancer lorsque l'utilisateur repond a un courrier */
    repondreCourrierAs: WorkflowType;
    /** Défini les config du module de recherche en fonction du workflow en cours */
    moduleRecherchePs: ModuleRecherchePs;
    /** Options spécifiques aux téléexpertises */
    teleExpertises: TeleExpertiseOptions;
}

export interface Anonymous {
    BoiteReception: CountByConversationStatus;
    Brouillon: CountByConversationStatus;
    nonLus: CountByConversationStatus;
    tous: CountByConversationStatus;
    Conversation: CountByConversationStatus;
    Courrier: CountByConversationStatus;
    Resultat: CountByConversationStatus;
    RendezVous: CountByConversationStatus;
    favoris: CountByConversationStatus;
    aTraiter: CountByConversationStatus;
    MSS: CountByConversationStatus;
    EchangePatient: CountByConversationStatus;
    DGS: CountByConversationStatus;
    MSSPatient: CountByConversationStatus;
    CourrierPatient: CountByConversationStatus;
    AucunType: CountByConversationStatus;
    TeleExpertise: CountByConversationStatus;
    DemandeAppui: CountByConversationStatus;
}

export interface Anonymous2 {
    BoiteReception: CountByConversationStatus;
    Brouillon: CountByConversationStatus;
    nonLus: CountByConversationStatus;
    tous: CountByConversationStatus;
    Conversation: CountByConversationStatus;
    Courrier: CountByConversationStatus;
    Resultat: CountByConversationStatus;
    RendezVous: CountByConversationStatus;
    favoris: CountByConversationStatus;
    aTraiter: CountByConversationStatus;
    MSS: CountByConversationStatus;
    EchangePatient: CountByConversationStatus;
    DGS: CountByConversationStatus;
    MSSPatient: CountByConversationStatus;
    CourrierPatient: CountByConversationStatus;
    AucunType: CountByConversationStatus;
    TeleExpertise: CountByConversationStatus;
    DemandeAppui: CountByConversationStatus;
}

export interface DefaultStates {
    BoiteReception: boolean;
    Brouillon: boolean;
    nonLus: boolean;
    tous: boolean;
    Conversation: boolean;
    Courrier: boolean;
    Resultat: boolean;
    RendezVous: boolean;
    favoris: boolean;
    aTraiter: boolean;
    MSS: boolean;
    EchangePatient: boolean;
    DGS: boolean;
    MSSPatient: boolean;
    CourrierPatient: boolean;
    AucunType: boolean;
    TeleExpertise: boolean;
    DemandeAppui: boolean;
}

export interface ModuleRecherchePs {
    CreateCourrierPs: ModuleRechercheConfig;
    CreateCourrierPatient: ModuleRechercheConfig;
    CreateMss: ModuleRechercheConfig;
    CreateConversation: ModuleRechercheConfig;
    CreateDemandeAppui: ModuleRechercheConfig;
    CreateTeleExpertise: ModuleRechercheConfig;
    EditConversation: ModuleRechercheConfig;
    EditDemandeAppui: ModuleRechercheConfig;
    EditTeleExpertise: ModuleRechercheConfig;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}